
export const horoscopeName_ar = ['برج الحمل', 'برج الثور', 'الجوزاء', 'سرطان', 'الأسد', 'برج العذراء', 'برج الميزان', 'العقرب', 'القوس', 'الجدي', 'الدلو', 'برج الحوت']
export const horoscopeDate_ar = ['مارس 21 - أبريل 19', 'أبريل 20 - مايو 20', 'مايو 21 - يونيو 20', 'يونيو 21 - يوليو 22', 'يوليو 23 - أغسطس 22', 'أغسطس 23 - سبتمبر 22', 'سبتمبر 23 - أكتوبر 22', 'أكتوبر 23 - نوفمبر 21', 'نوفمبر 22 - ديسمبر 21', 'ديسمبر 22 - يناير 19', 'يناير 20 - فبراير 18', 'فبراير 19 - مارس 20']
export const ratings_ar = {
    'برج الحمل': {
        love: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 2,
            5: 4,
            6: 3,
            7: 5,
            8: 4,
            9: 2
        },
        mood: {
            0: 3,
            1: 4,
            2: 4,
            3: 2,
            4: 3,
            5: 4,
            6: 2,
            7: 4,
            8: 3,
            9: 2

        },
        money: {
            0: 4,
            1: 3,
            2: 2,
            3: 2,
            4: 4,
            5: 3,
            6: 2,
            7: 4,
            8: 2,
            9: 5

        },
        career: {
            0: 5,
            1: 4,
            2: 2,
            3: 1,
            4: 2,
            5: 3,
            6: 4,
            7: 5,
            8: 4,
            9: 3

        }
    },
    'برج الثور': {
        love: {
            0: 3,
            1: 4,
            2: 4,
            3: 5,
            4: 3,
            5: 4,
            6: 2,
            7: 4,
            8: 3,
            9: 2

        },
        mood: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 2,
            5: 4,
            6: 3,
            7: 5,
            8: 4,
            9: 2

        },
        money: {
            0: 5,
            1: 4,
            2: 2,
            3: 4,
            4: 2,
            5: 3,
            6: 4,
            7: 5,
            8: 4,
            9: 3

        },
        career: {
            0: 4,
            1: 3,
            2: 2,
            3: 5,
            4: 4,
            5: 3,
            6: 2,
            7: 4,
            8: 2,
            9: 5
        }
    },
    'الجوزاء': {
        love: {
            0: 5,
            1: 4,
            2: 4,
            3: 3,
            4: 5,
            5: 2,
            6: 4,
            7: 3,
            8: 4,
            9: 2

        },
        mood: {
            0: 4,
            1: 3,
            2: 2,
            3: 4,
            4: 3,
            5: 4,
            6: 5,
            7: 4,
            8: 4,
            9: 2

        },
        money: {
            0: 4,
            1: 3,
            2: 2,
            3: 4,
            4: 3,
            5: 4,
            6: 5,
            7: 2,
            8: 1,
            9: 2

        },
        career: {
            0: 4,
            1: 5,
            2: 2,
            3: 3,
            4: 2,
            5: 3,
            6: 5,
            7: 3,
            8: 2,
            9: 5

        }
    },
    'سرطان': {
        love: {
            0: 4,
            1: 3,
            2: 2,
            3: 5,
            4: 4,
            5: 3,
            6: 2,
            7: 4,
            8: 2,
            9: 5
        },
        mood: {
            0: 5,
            1: 4,
            2: 2,
            3: 4,
            4: 2,
            5: 3,
            6: 4,
            7: 5,
            8: 4,
            9: 3
        },
        money: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 2,
            5: 4,
            6: 3,
            7: 5,
            8: 4,
            9: 2

        },
        career: {
            0: 3,
            1: 4,
            2: 4,
            3: 5,
            4: 3,
            5: 4,
            6: 2,
            7: 4,
            8: 3,
            9: 2

        }
    },
    'الأسد': {
        love: {
            0: 3,
            1: 4,
            2: 5,
            3: 5,
            4: 3,
            5: 2,
            6: 3,
            7: 5,
            8: 1,
            9: 3

        },
        mood: {
            0: 4,
            1: 3,
            2: 5,
            3: 4,
            4: 2,
            5: 1,
            6: 4,
            7: 5,
            8: 2,
            9: 1

        },
        money: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 4,
            5: 2,
            6: 1,
            7: 2,
            8: 5,
            9: 4

        },
        career: {
            0: 3,
            1: 4,
            2: 5,
            3: 2,
            4: 4,
            5: 2,
            6: 3,
            7: 5,
            8: 1,
            9: 3

        }
    },
    'برج العذراء': {
        love: {
            0: 4,
            1: 3,
            2: 5,
            3: 4,
            4: 2,
            5: 1,
            6: 5,
            7: 3,
            8: 2,
            9: 1

        },
        mood: {
            0: 3,
            1: 4,
            2: 5,
            3: 2,
            4: 1,
            5: 2,
            6: 3,
            7: 2,
            8: 2,
            9: 1

        },
        money: {
            0: 2,
            1: 3,
            2: 4,
            3: 2,
            4: 2,
            5: 2,
            6: 5,
            7: 3,
            8: 5,
            9: 4

        },
        career: {
            0: 3,
            1: 2,
            2: 2,
            3: 1,
            4: 2,
            5: 2,
            6: 3,
            7: 2,
            8: 3,
            9: 1

        }
    },
    'برج الميزان': {
        love: {
            0: 3,
            1: 4,
            2: 4,
            3: 5,
            4: 3,
            5: 4,
            6: 2,
            7: 4,
            8: 3,
            9: 2

        },
        mood: {
            0: 3,
            1: 4,
            2: 5,
            3: 2,
            4: 1,
            5: 2,
            6: 3,
            7: 2,
            8: 2,
            9: 1

        },
        money: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 4,
            5: 2,
            6: 1,
            7: 2,
            8: 5,
            9: 4

        },
        career: {
            0: 4,
            1: 5,
            2: 2,
            3: 3,
            4: 2,
            5: 3,
            6: 5,
            7: 3,
            8: 2,
            9: 5

        }
    },
    'العقرب': {
        love: {
            0: 5,
            1: 4,
            2: 4,
            3: 3,
            4: 5,
            5: 2,
            6: 4,
            7: 3,
            8: 4,
            9: 2
        },
        mood: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 2,
            5: 4,
            6: 3,
            7: 5,
            8: 4,
            9: 2
        },
        money: {
            0: 4,
            1: 3,
            2: 2,
            3: 5,
            4: 4,
            5: 3,
            6: 2,
            7: 4,
            8: 2,
            9: 5

        },
        career: {
            0: 5,
            1: 4,
            2: 2,
            3: 4,
            4: 2,
            5: 3,
            6: 4,
            7: 5,
            8: 4,
            9: 3

        }
    },
    'القوس': {
        love: {
            0: 3,
            1: 2,
            2: 5,
            3: 4,
            4: 3,
            5: 5,
            6: 4,
            7: 3,
            8: 2,
            9: 5

        },
        mood: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 2,
            5: 4,
            6: 3,
            7: 5,
            8: 4,
            9: 2

        },
        money: {
            0: 5,
            1: 4,
            2: 3,
            3: 4,
            4: 2,
            5: 5,
            6: 4,
            7: 3,
            8: 5,
            9: 4
        },
        career: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 4,
            5: 2,
            6: 1,
            7: 2,
            8: 5,
            9: 4

        }
    },
    'الجدي': {
        love: {
            0: 4,
            1: 3,
            2: 5,
            3: 4,
            4: 2,
            5: 1,
            6: 4,
            7: 5,
            8: 2,
            9: 1

        },
        mood: {
            0: 3,
            1: 4,
            2: 5,
            3: 2,
            4: 4,
            5: 2,
            6: 3,
            7: 5,
            8: 1,
            9: 3

        },
        money: {
            0: 5,
            1: 4,
            2: 3,
            3: 4,
            4: 2,
            5: 5,
            6: 4,
            7: 3,
            8: 5,
            9: 4

        },
        career: {
            0: 4,
            1: 3,
            2: 5,
            3: 4,
            4: 2,
            5: 1,
            6: 4,
            7: 5,
            8: 2,
            9: 1
        }
    },
    'الدلو': {
        love: {
            0: 3,
            1: 4,
            2: 5,
            3: 2,
            4: 1,
            5: 2,
            6: 3,
            7: 2,
            8: 2,
            9: 1

        },
        mood: {
            0: 3,
            1: 4,
            2: 5,
            3: 2,
            4: 1,
            5: 2,
            6: 3,
            7: 2,
            8: 2,
            9: 1

        },
        money: {
            0: 4,
            1: 3,
            2: 5,
            3: 4,
            4: 2,
            5: 1,
            6: 5,
            7: 3,
            8: 2,
            9: 1
        },
        career: {
            0: 5,
            1: 4,
            2: 3,
            3: 4,
            4: 2,
            5: 5,
            6: 4,
            7: 3,
            8: 5,
            9: 4

        }
    },
    'برج الحوت': {
        love: {
            0: 3,
            1: 4,
            2: 4,
            3: 5,
            4: 3,
            5: 4,
            6: 2,
            7: 4,
            8: 3,
            9: 2

        },
        mood: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 2,
            5: 4,
            6: 3,
            7: 5,
            8: 4,
            9: 2

        },
        money: {
            0: 5,
            1: 4,
            2: 2,
            3: 4,
            4: 2,
            5: 3,
            6: 4,
            7: 5,
            8: 4,
            9: 3

        },
        career: {
            0: 4,
            1: 3,
            2: 2,
            3: 5,
            4: 4,
            5: 3,
            6: 2,
            7: 4,
            8: 2,
            9: 5

        }
    }

}

export const horoscopes_ar = {
    'برج الحمل': {
        sun_sign: {
            0: `عاطفيًا: تتوقع ماغي فرح خبيرة الأبراج أن تنفتح العلاقات في هذا العام الجديد أمام برج الحمل
سوف تتطوّر العلاقات مع الجنس الآخر بشكل إيجابي
وكبير وستلاحظ تغييرًا هائلاً في حياتك العاطفية، عليك فقط أن تتريث دائمًا في الحمل على الأمور وبخاصةً أمورك العاطفية
سنة 2020 ليست مثالية للمشاريع العائلية أو الدخول بشراكة عائلية.
ينصحك الفلك بعدم الدخول في علاقة عاطفية جديدة، لا سيما إذا كانت عابرة.`,
            1: `يحمل لك عام 2020 إنجازات ونجاحات مهمة جدًا، حيث نجد عطارك والمريخ وأورانوس
دخلوا لبرج القوس، والقوس من الأبراج النارية مثلك تمامًا، وهذا يعدك بأحداث جيدة جدًا بداية من الشهر الأخير فى عام 2019 وبداية 2020، حيث ستكون علي موعد مع نجاحات وتطورات هامة جدًا في حياتك المهنية والمالية
وتتحسن أوضاعك المالية  بشكل كبير جدًا، وربما يحدث كثير من الأمور الغير متوقعة
بحيث يعرض عليك أشخاص بعض المشاريع الوهمية. عليك الاحتراس من الخوض معهم في تلك المشاريع
لأن ربما يكونوا من فئة النصابين توخّى الحذر وكن منتبهًا خاصةً في فصل الربيع.

توقعات الأبراج 2020 ماغي فرح “برج الثور”
برج الثور: برج الثور هو البرج الثاني من الأبراج الاثنى عشر الشمسية، فتمر الشمس في برج الثور في الفترة
(من 12 إبريل وحتى 21 مايو)، فهو برج ربيعي يسيطر عليه كوكب الزهرة ومن أحجاره الكريمة: الزمرد والفيروز.
يتوافق مع برج العقرب، والعذراء، والجدي، ولا يتوافق مع برج الحمل، والقوس، والجوزاء.`,

            0: `عاطفيًا: تتوقع ماغي فرح خبيرة الأبراج أن تنفتح العلاقات في هذا العام الجديد أمام برج الحمل
سوف تتطوّر العلاقات مع الجنس الآخر بشكل إيجابي
وكبير وستلاحظ تغييرًا هائلاً في حياتك العاطفية، عليك فقط أن تتريث دائمًا في الحمل على الأمور وبخاصةً أمورك العاطفية
سنة 2020 ليست مثالية للمشاريع العائلية أو الدخول بشراكة عائلية.
ينصحك الفلك بعدم الدخول في علاقة عاطفية جديدة، لا سيما إذا كانت عابرة.`,
            1: `يحمل لك عام 2020 إنجازات ونجاحات مهمة جدًا، حيث نجد عطارك والمريخ وأورانوس
دخلوا لبرج القوس، والقوس من الأبراج النارية مثلك تمامًا، وهذا يعدك بأحداث جيدة جدًا بداية من الشهر الأخير فى عام 2019 وبداية 2020، حيث ستكون علي موعد مع نجاحات وتطورات هامة جدًا في حياتك المهنية والمالية
وتتحسن أوضاعك المالية  بشكل كبير جدًا، وربما يحدث كثير من الأمور الغير متوقعة
بحيث يعرض عليك أشخاص بعض المشاريع الوهمية. عليك الاحتراس من الخوض معهم في تلك المشاريع
لأن ربما يكونوا من فئة النصابين توخّى الحذر وكن منتبهًا خاصةً في فصل الربيع.

توقعات الأبراج 2020 ماغي فرح “برج الثور”
برج الثور: برج الثور هو البرج الثاني من الأبراج الاثنى عشر الشمسية، فتمر الشمس في برج الثور في الفترة
(من 12 إبريل وحتى 21 مايو)، فهو برج ربيعي يسيطر عليه كوكب الزهرة ومن أحجاره الكريمة: الزمرد والفيروز.
يتوافق مع برج العقرب، والعذراء، والجدي، ولا يتوافق مع برج الحمل، والقوس، والجوزاء.`,
            2: `عاطفيًا: تتوقع ماغي فرح خبيرة الأبراج أن تنفتح العلاقات في هذا العام الجديد أمام برج الحمل
سوف تتطوّر العلاقات مع الجنس الآخر بشكل إيجابي
وكبير وستلاحظ تغييرًا هائلاً في حياتك العاطفية، عليك فقط أن تتريث دائمًا في الحمل على الأمور وبخاصةً أمورك العاطفية
سنة 2020 ليست مثالية للمشاريع العائلية أو الدخول بشراكة عائلية.
ينصحك الفلك بعدم الدخول في علاقة عاطفية جديدة، لا سيما إذا كانت عابرة.`,
            3: `يحمل لك عام 2020 إنجازات ونجاحات مهمة جدًا، حيث نجد عطارك والمريخ وأورانوس
دخلوا لبرج القوس، والقوس من الأبراج النارية مثلك تمامًا، وهذا يعدك بأحداث جيدة جدًا بداية من الشهر الأخير فى عام 2019 وبداية 2020، حيث ستكون علي موعد مع نجاحات وتطورات هامة جدًا في حياتك المهنية والمالية
وتتحسن أوضاعك المالية  بشكل كبير جدًا، وربما يحدث كثير من الأمور الغير متوقعة
بحيث يعرض عليك أشخاص بعض المشاريع الوهمية. عليك الاحتراس من الخوض معهم في تلك المشاريع
لأن ربما يكونوا من فئة النصابين توخّى الحذر وكن منتبهًا خاصةً في فصل الربيع.

توقعات الأبراج 2020 ماغي فرح “برج الثور”
برج الثور: برج الثور هو البرج الثاني من الأبراج الاثنى عشر الشمسية، فتمر الشمس في برج الثور في الفترة
(من 12 إبريل وحتى 21 مايو)، فهو برج ربيعي يسيطر عليه كوكب الزهرة ومن أحجاره الكريمة: الزمرد والفيروز.
يتوافق مع برج العقرب، والعذراء، والجدي، ولا يتوافق مع برج الحمل، والقوس، والجوزاء.`,
               4: `عاطفيًا: تتوقع ماغي فرح خبيرة الأبراج أن تنفتح العلاقات في هذا العام الجديد أمام برج الحمل
سوف تتطوّر العلاقات مع الجنس الآخر بشكل إيجابي
وكبير وستلاحظ تغييرًا هائلاً في حياتك العاطفية، عليك فقط أن تتريث دائمًا في الحمل على الأمور وبخاصةً أمورك العاطفية
سنة 2020 ليست مثالية للمشاريع العائلية أو الدخول بشراكة عائلية.
ينصحك الفلك بعدم الدخول في علاقة عاطفية جديدة، لا سيما إذا كانت عابرة.`,
            5: `يحمل لك عام 2020 إنجازات ونجاحات مهمة جدًا، حيث نجد عطارك والمريخ وأورانوس
دخلوا لبرج القوس، والقوس من الأبراج النارية مثلك تمامًا، وهذا يعدك بأحداث جيدة جدًا بداية من الشهر الأخير فى عام 2019 وبداية 2020، حيث ستكون علي موعد مع نجاحات وتطورات هامة جدًا في حياتك المهنية والمالية
وتتحسن أوضاعك المالية  بشكل كبير جدًا، وربما يحدث كثير من الأمور الغير متوقعة
بحيث يعرض عليك أشخاص بعض المشاريع الوهمية. عليك الاحتراس من الخوض معهم في تلك المشاريع
لأن ربما يكونوا من فئة النصابين توخّى الحذر وكن منتبهًا خاصةً في فصل الربيع.

توقعات الأبراج 2020 ماغي فرح “برج الثور”
برج الثور: برج الثور هو البرج الثاني من الأبراج الاثنى عشر الشمسية، فتمر الشمس في برج الثور في الفترة
(من 12 إبريل وحتى 21 مايو)، فهو برج ربيعي يسيطر عليه كوكب الزهرة ومن أحجاره الكريمة: الزمرد والفيروز.
يتوافق مع برج العقرب، والعذراء، والجدي، ولا يتوافق مع برج الحمل، والقوس، والجوزاء.`,
               6: `عاطفيًا: تتوقع ماغي فرح خبيرة الأبراج أن تنفتح العلاقات في هذا العام الجديد أمام برج الحمل
سوف تتطوّر العلاقات مع الجنس الآخر بشكل إيجابي
وكبير وستلاحظ تغييرًا هائلاً في حياتك العاطفية، عليك فقط أن تتريث دائمًا في الحمل على الأمور وبخاصةً أمورك العاطفية
سنة 2020 ليست مثالية للمشاريع العائلية أو الدخول بشراكة عائلية.
ينصحك الفلك بعدم الدخول في علاقة عاطفية جديدة، لا سيما إذا كانت عابرة.`,
            7: `يحمل لك عام 2020 إنجازات ونجاحات مهمة جدًا، حيث نجد عطارك والمريخ وأورانوس
دخلوا لبرج القوس، والقوس من الأبراج النارية مثلك تمامًا، وهذا يعدك بأحداث جيدة جدًا بداية من الشهر الأخير فى عام 2019 وبداية 2020، حيث ستكون علي موعد مع نجاحات وتطورات هامة جدًا في حياتك المهنية والمالية
وتتحسن أوضاعك المالية  بشكل كبير جدًا، وربما يحدث كثير من الأمور الغير متوقعة
بحيث يعرض عليك أشخاص بعض المشاريع الوهمية. عليك الاحتراس من الخوض معهم في تلك المشاريع
لأن ربما يكونوا من فئة النصابين توخّى الحذر وكن منتبهًا خاصةً في فصل الربيع.

توقعات الأبراج 2020 ماغي فرح “برج الثور”
برج الثور: برج الثور هو البرج الثاني من الأبراج الاثنى عشر الشمسية، فتمر الشمس في برج الثور في الفترة
(من 12 إبريل وحتى 21 مايو)، فهو برج ربيعي يسيطر عليه كوكب الزهرة ومن أحجاره الكريمة: الزمرد والفيروز.
يتوافق مع برج العقرب، والعذراء، والجدي، ولا يتوافق مع برج الحمل، والقوس، والجوزاء.`,
            8: `عاطفيًا: تتوقع ماغي فرح خبيرة الأبراج أن تنفتح العلاقات في هذا العام الجديد أمام برج الحمل
سوف تتطوّر العلاقات مع الجنس الآخر بشكل إيجابي
وكبير وستلاحظ تغييرًا هائلاً في حياتك العاطفية، عليك فقط أن تتريث دائمًا في الحمل على الأمور وبخاصةً أمورك العاطفية
سنة 2020 ليست مثالية للمشاريع العائلية أو الدخول بشراكة عائلية.
ينصحك الفلك بعدم الدخول في علاقة عاطفية جديدة، لا سيما إذا كانت عابرة.`,
            9: `يحمل لك عام 2020 إنجازات ونجاحات مهمة جدًا، حيث نجد عطارك والمريخ وأورانوس
دخلوا لبرج القوس، والقوس من الأبراج النارية مثلك تمامًا، وهذا يعدك بأحداث جيدة جدًا بداية من الشهر الأخير فى عام 2019 وبداية 2020، حيث ستكون علي موعد مع نجاحات وتطورات هامة جدًا في حياتك المهنية والمالية
وتتحسن أوضاعك المالية  بشكل كبير جدًا، وربما يحدث كثير من الأمور الغير متوقعة
بحيث يعرض عليك أشخاص بعض المشاريع الوهمية. عليك الاحتراس من الخوض معهم في تلك المشاريع
لأن ربما يكونوا من فئة النصابين توخّى الحذر وكن منتبهًا خاصةً في فصل الربيع.

توقعات الأبراج 2020 ماغي فرح “برج الثور”
برج الثور: برج الثور هو البرج الثاني من الأبراج الاثنى عشر الشمسية، فتمر الشمس في برج الثور في الفترة
(من 12 إبريل وحتى 21 مايو)، فهو برج ربيعي يسيطر عليه كوكب الزهرة ومن أحجاره الكريمة: الزمرد والفيروز.
يتوافق مع برج العقرب، والعذراء، والجدي، ولا يتوافق مع برج الحمل، والقوس، والجوزاء.`,
            31: `عاطفيًا: تتوقع ماغي فرح خبيرة الأبراج أن تنفتح العلاقات في هذا العام الجديد أمام برج الحمل
سوف تتطوّر العلاقات مع الجنس الآخر بشكل إيجابي
وكبير وستلاحظ تغييرًا هائلاً في حياتك العاطفية، عليك فقط أن تتريث دائمًا في الحمل على الأمور وبخاصةً أمورك العاطفية
سنة 2020 ليست مثالية للمشاريع العائلية أو الدخول بشراكة عائلية.
ينصحك الفلك بعدم الدخول في علاقة عاطفية جديدة، لا سيما إذا كانت عابرة.`                                            
           
        }
    },
    'برج الثور': {
        sun_sign: {
            0: `إذا كان لديك مشكلة عاطفية سابقة ، فستجد حلاً لهذا العام
سيكون لديك اجتماع هذا العام مع حبيبك ، ومع بعض الأشخاص الآخرين أو مع أفراد عائلتك لجمع شيء جديد
قد تكون مناسبة أو احتفال لما حدث على سبيل الإمكان أن تكون طارئًا يجمع العائلة معًا ،
الاستفادة من هذه الفرص والتجمعات ، وسوف تجد نفسك سعيدا مع هذه الاجتماعات أيضا.`,
            1: `ستجلب لك الأشهر الأولى من عام 2020 آمالًا جديدة ورياحًا جديدة للتغير ، على الرغم من وجودها
بعض العقبات الصغيرة التي سوف ترافقك من 2019 ، ولكنك ستتمكن من التغلب عليها بسهولة.
سوف الثور تواجه الكثير من التذبذبات بين الصعود والهبوط ، التذبذبات
والتغيرات بين الإيجابية والسلبية في القطاع المالي ، وخاصة بين أوائل أبريل وأوائل أغسطس`,
            2: `إذا كان لديك مشكلة عاطفية سابقة ، فستجد حلاً لهذا العام
سيكون لديك اجتماع هذا العام مع حبيبك ، ومع بعض الأشخاص الآخرين أو مع أفراد عائلتك لجمع شيء جديد
قد تكون مناسبة أو احتفال لما حدث على سبيل الإمكان أن تكون طارئًا يجمع العائلة معًا ،
الاستفادة من هذه الفرص والتجمعات ، وسوف تجد نفسك سعيدا مع هذه الاجتماعات أيضا.`,
            3: `ستجلب لك الأشهر الأولى من عام 2020 آمالًا جديدة ورياحًا جديدة للتغير ، على الرغم من وجودها
بعض العقبات الصغيرة التي سوف ترافقك من 2019 ، ولكنك ستتمكن من التغلب عليها بسهولة.
سوف الثور تواجه الكثير من التذبذبات بين الصعود والهبوط ، التذبذبات
والتغيرات بين الإيجابية والسلبية في القطاع المالي ، وخاصة بين أوائل أبريل وأوائل أغسطس`,
            4: `إذا كان لديك مشكلة عاطفية سابقة ، فستجد حلاً لهذا العام
سيكون لديك اجتماع هذا العام مع حبيبك ، ومع بعض الأشخاص الآخرين أو مع أفراد عائلتك لجمع شيء جديد
قد تكون مناسبة أو احتفال لما حدث على سبيل الإمكان أن تكون طارئًا يجمع العائلة معًا ،
الاستفادة من هذه الفرص والتجمعات ، وسوف تجد نفسك سعيدا مع هذه الاجتماعات أيضا.`,
            5: `ستجلب لك الأشهر الأولى من عام 2020 آمالًا جديدة ورياحًا جديدة للتغير ، على الرغم من وجودها
بعض العقبات الصغيرة التي سوف ترافقك من 2019 ، ولكنك ستتمكن من التغلب عليها بسهولة.
سوف الثور تواجه الكثير من التذبذبات بين الصعود والهبوط ، التذبذبات
والتغيرات بين الإيجابية والسلبية في القطاع المالي ، وخاصة بين أوائل أبريل وأوائل أغسطس`,
            6: `إذا كان لديك مشكلة عاطفية سابقة ، فستجد حلاً لهذا العام
سيكون لديك اجتماع هذا العام مع حبيبك ، ومع بعض الأشخاص الآخرين أو مع أفراد عائلتك لجمع شيء جديد
قد تكون مناسبة أو احتفال لما حدث على سبيل الإمكان أن تكون طارئًا يجمع العائلة معًا ،
الاستفادة من هذه الفرص والتجمعات ، وسوف تجد نفسك سعيدا مع هذه الاجتماعات أيضا.`,
            7: `ستجلب لك الأشهر الأولى من عام 2020 آمالًا جديدة ورياحًا جديدة للتغير ، على الرغم من وجودها
بعض العقبات الصغيرة التي سوف ترافقك من 2019 ، ولكنك ستتمكن من التغلب عليها بسهولة.
سوف الثور تواجه الكثير من التذبذبات بين الصعود والهبوط ، التذبذبات
والتغيرات بين الإيجابية والسلبية في القطاع المالي ، وخاصة بين أوائل أبريل وأوائل أغسطس`,
            8: `إذا كان لديك مشكلة عاطفية سابقة ، فستجد حلاً لهذا العام
سيكون لديك اجتماع هذا العام مع حبيبك ، ومع بعض الأشخاص الآخرين أو مع أفراد عائلتك لجمع شيء جديد
قد تكون مناسبة أو احتفال لما حدث على سبيل الإمكان أن تكون طارئًا يجمع العائلة معًا ،
الاستفادة من هذه الفرص والتجمعات ، وسوف تجد نفسك سعيدا مع هذه الاجتماعات أيضا.`,
            9: `ستجلب لك الأشهر الأولى من عام 2020 آمالًا جديدة ورياحًا جديدة للتغير ، على الرغم من وجودها
بعض العقبات الصغيرة التي سوف ترافقك من 2019 ، ولكنك ستتمكن من التغلب عليها بسهولة.
سوف الثور تواجه الكثير من التذبذبات بين الصعود والهبوط ، التذبذبات
والتغيرات بين الإيجابية والسلبية في القطاع المالي ، وخاصة بين أوائل أبريل وأوائل أغسطس`,
            31: `إذا كان لديك مشكلة عاطفية سابقة ، فستجد حلاً لهذا العام
سيكون لديك اجتماع هذا العام مع حبيبك ، ومع بعض الأشخاص الآخرين أو مع أفراد عائلتك لجمع شيء جديد
قد تكون مناسبة أو احتفال لما حدث على سبيل الإمكان أن تكون طارئًا يجمع العائلة معًا ،
الاستفادة من هذه الفرص والتجمعات ، وسوف تجد نفسك سعيدا مع هذه الاجتماعات أيضا.`,
           
        },
        
    },
    'الجوزاء': {
        sun_sign: {
            0: `2020
يعدك بسنة مثيرة للدهشة. هناك احتمال أن يدخل شخص جديد حياتك في منتصف هذا العام ، وكذلك من سبتمبر إلى نوفمبر ، وسيحدد تفاعلك مع شريكك خارطة الطريق الخاصة بك
العلاقة المستقبلية. سيزودك شريكك الجديد بالاستقرار العاطفي والدعم المعنوي ، وهو ما فاتني دائماً في الفترات السابقة.
ولكن كن حذرا من الوقوع في المشاكل العاطفية مع شريك حياتك السابق`,
            1: `وتتوقع ماجي فرح ، عالمة فلك وخبيرة في تشكيل الكوكبة اللبنانية ، الكثير من الفرص الجيدة
في الطريق إليك هذا العام ، خاصة من 16 سبتمبر إلى 22 أكتوبر ،
عندما ستشهد تغييرات إيجابية وحاسمة في حياتك المهنية والاجتماعية
إذا كنت تفكر في مهنة مختلفة أو تحاول الانضمام إلى شركة مختلفة في نفس المجال ، تأكد من أنك تسير في الاتجاه الصحيح.
ستساعدك هذه الأشهر على تعويض أي شيء خسرته قبل هذه الأيام. سيكون لديك فترة من التوتر والتوتر مع العديد من الناس ،
خصوصا أولئك الذين لم يحفظوا وعودهم لك. ومع ذلك ، ستكون هناك فرص وظيفية جديدة حيث ستحصل على ترقية أو مكافأة مالية.
ولكن كن حذرا جدا مع عملك (22 مارس - 26 أبريل) ، حيث قد يؤدي ذلك إلى عقبات و
مشاكل بالنسبة لك`,
            2: `2020
يعدك بسنة مثيرة للدهشة. هناك احتمال أن يدخل شخص جديد حياتك في منتصف هذا العام ، وكذلك من سبتمبر إلى نوفمبر ، وسيحدد تفاعلك مع شريكك خارطة الطريق الخاصة بك
العلاقة المستقبلية. سيزودك شريكك الجديد بالاستقرار العاطفي والدعم المعنوي ، وهو ما فاتني دائماً في الفترات السابقة.
ولكن كن حذرا من الوقوع في المشاكل العاطفية مع شريك حياتك السابق`,
            3: `وتتوقع ماجي فرح ، عالمة فلك وخبيرة في تشكيل الكوكبة اللبنانية ، الكثير من الفرص الجيدة
في الطريق إليك هذا العام ، خاصة من 16 سبتمبر إلى 22 أكتوبر ،
عندما ستشهد تغييرات إيجابية وحاسمة في حياتك المهنية والاجتماعية
إذا كنت تفكر في مهنة مختلفة أو تحاول الانضمام إلى شركة مختلفة في نفس المجال ، تأكد من أنك تسير في الاتجاه الصحيح.
ستساعدك هذه الأشهر على تعويض أي شيء خسرته قبل هذه الأيام. سيكون لديك فترة من التوتر والتوتر مع العديد من الناس ،
خصوصا أولئك الذين لم يحفظوا وعودهم لك. ومع ذلك ، ستكون هناك فرص وظيفية جديدة حيث ستحصل على ترقية أو مكافأة مالية.
ولكن كن حذرا جدا مع عملك (22 مارس - 26 أبريل) ، حيث قد يؤدي ذلك إلى عقبات و
مشاكل بالنسبة لك`,
            4: `2020
يعدك بسنة مثيرة للدهشة. هناك احتمال أن يدخل شخص جديد حياتك في منتصف هذا العام ، وكذلك من سبتمبر إلى نوفمبر ، وسيحدد تفاعلك مع شريكك خارطة الطريق الخاصة بك
العلاقة المستقبلية. سيزودك شريكك الجديد بالاستقرار العاطفي والدعم المعنوي ، وهو ما فاتني دائماً في الفترات السابقة.
ولكن كن حذرا من الوقوع في المشاكل العاطفية مع شريك حياتك السابق`,
            5: `وتتوقع ماجي فرح ، عالمة فلك وخبيرة في تشكيل الكوكبة اللبنانية ، الكثير من الفرص الجيدة
في الطريق إليك هذا العام ، خاصة من 16 سبتمبر إلى 22 أكتوبر ،
عندما ستشهد تغييرات إيجابية وحاسمة في حياتك المهنية والاجتماعية
إذا كنت تفكر في مهنة مختلفة أو تحاول الانضمام إلى شركة مختلفة في نفس المجال ، تأكد من أنك تسير في الاتجاه الصحيح.
ستساعدك هذه الأشهر على تعويض أي شيء خسرته قبل هذه الأيام. سيكون لديك فترة من التوتر والتوتر مع العديد من الناس ،
خصوصا أولئك الذين لم يحفظوا وعودهم لك. ومع ذلك ، ستكون هناك فرص وظيفية جديدة حيث ستحصل على ترقية أو مكافأة مالية.
ولكن كن حذرا جدا مع عملك (22 مارس - 26 أبريل) ، حيث قد يؤدي ذلك إلى عقبات و
مشاكل بالنسبة لك`,
            6: `2020
يعدك بسنة مثيرة للدهشة. هناك احتمال أن يدخل شخص جديد حياتك في منتصف هذا العام ، وكذلك من سبتمبر إلى نوفمبر ، وسيحدد تفاعلك مع شريكك خارطة الطريق الخاصة بك
العلاقة المستقبلية. سيزودك شريكك الجديد بالاستقرار العاطفي والدعم المعنوي ، وهو ما فاتني دائماً في الفترات السابقة.
ولكن كن حذرا من الوقوع في المشاكل العاطفية مع شريك حياتك السابق`,
            7: `وتتوقع ماجي فرح ، عالمة فلك وخبيرة في تشكيل الكوكبة اللبنانية ، الكثير من الفرص الجيدة
في الطريق إليك هذا العام ، خاصة من 16 سبتمبر إلى 22 أكتوبر ،
عندما ستشهد تغييرات إيجابية وحاسمة في حياتك المهنية والاجتماعية
إذا كنت تفكر في مهنة مختلفة أو تحاول الانضمام إلى شركة مختلفة في نفس المجال ، تأكد من أنك تسير في الاتجاه الصحيح.
ستساعدك هذه الأشهر على تعويض أي شيء خسرته قبل هذه الأيام. سيكون لديك فترة من التوتر والتوتر مع العديد من الناس ،
خصوصا أولئك الذين لم يحفظوا وعودهم لك. ومع ذلك ، ستكون هناك فرص وظيفية جديدة حيث ستحصل على ترقية أو مكافأة مالية.
ولكن كن حذرا جدا مع عملك (22 مارس - 26 أبريل) ، حيث قد يؤدي ذلك إلى عقبات و
مشاكل بالنسبة لك`,
            8: `2020
يعدك بسنة مثيرة للدهشة. هناك احتمال أن يدخل شخص جديد حياتك في منتصف هذا العام ، وكذلك من سبتمبر إلى نوفمبر ، وسيحدد تفاعلك مع شريكك خارطة الطريق الخاصة بك
العلاقة المستقبلية. سيزودك شريكك الجديد بالاستقرار العاطفي والدعم المعنوي ، وهو ما فاتني دائماً في الفترات السابقة.
ولكن كن حذرا من الوقوع في المشاكل العاطفية مع شريك حياتك السابق`,
            9: `وتتوقع ماجي فرح ، عالمة فلك وخبيرة في تشكيل الكوكبة اللبنانية ، الكثير من الفرص الجيدة
في الطريق إليك هذا العام ، خاصة من 16 سبتمبر إلى 22 أكتوبر ،
عندما ستشهد تغييرات إيجابية وحاسمة في حياتك المهنية والاجتماعية
إذا كنت تفكر في مهنة مختلفة أو تحاول الانضمام إلى شركة مختلفة في نفس المجال ، تأكد من أنك تسير في الاتجاه الصحيح.
ستساعدك هذه الأشهر على تعويض أي شيء خسرته قبل هذه الأيام. سيكون لديك فترة من التوتر والتوتر مع العديد من الناس ،
خصوصا أولئك الذين لم يحفظوا وعودهم لك. ومع ذلك ، ستكون هناك فرص وظيفية جديدة حيث ستحصل على ترقية أو مكافأة مالية.
ولكن كن حذرا جدا مع عملك (22 مارس - 26 أبريل) ، حيث قد يؤدي ذلك إلى عقبات و
مشاكل بالنسبة لك`,
            31: `2020
يعدك بسنة مثيرة للدهشة. هناك احتمال أن يدخل شخص جديد حياتك في منتصف هذا العام ، وكذلك من سبتمبر إلى نوفمبر ، وسيحدد تفاعلك مع شريكك خارطة الطريق الخاصة بك
العلاقة المستقبلية. سيزودك شريكك الجديد بالاستقرار العاطفي والدعم المعنوي ، وهو ما فاتني دائماً في الفترات السابقة.
ولكن كن حذرا من الوقوع في المشاكل العاطفية مع شريك حياتك السابق`,
            
        }
    },
    'سرطان': {
        sun_sign: {
            0: `
الحب يطرق مرة أخرى ، لذلك يجب الاستفادة من الفرص التي منحته بشكل جيد.
الابتعاد عن تحليل الأمور والدخول في التفاصيل في علاقتك مع شريك حياتك ، وخاصة إذا كانت العلاقة متوترة.
ستحدد علاقتك مع الشريك إما عن طريق الاستمرار أو إنهاء العلاقة.
أبواب الزواج مفتوحة على مصراعيها ، وينتظر حفل الزفاف لأبناء هذا البرج هذا العام
. أما بالنسبة للمتزوج ، فإن الحياة تسير بينهما دون مشاكل في معظم الأحيان وفهم بعضنا البعض`,
            1: `سيكون هناك تطورات جيدة للغاية على المستوى المهني لأطفال برج السرطان.
على الرغم من الانتقادات ، سوف تتقدم باحتراف وقد تسعى إلى تحسين البيئة المهنية الخاصة بك
في أكثر من موقع واتجاه واحد في نفس الوقت. معظم الوقت ستحرز تقدمًا ممتازًا إما عن طريق الترقية إلى موضع أعلى
أو سيكون هناك بعض العروض المقترحة في الغالب خلال شهر مارس يجب تحذيرها
من القرارات والتفكير الكثير قبل اتخاذها ، وخاصة مارس ويونيو ، فإن العمل لن يعطيك كل ما تريد`,
            2: `
الحب يطرق مرة أخرى ، لذلك يجب الاستفادة من الفرص التي منحته بشكل جيد.
الابتعاد عن تحليل الأمور والدخول في التفاصيل في علاقتك مع شريك حياتك ، وخاصة إذا كانت العلاقة متوترة.
ستحدد علاقتك مع الشريك إما عن طريق الاستمرار أو إنهاء العلاقة.
أبواب الزواج مفتوحة على مصراعيها ، وينتظر حفل الزفاف لأبناء هذا البرج هذا العام
. أما بالنسبة للمتزوج ، فإن الحياة تسير بينهما دون مشاكل في معظم الأحيان وفهم بعضنا البعض`,
            3: `سيكون هناك تطورات جيدة للغاية على المستوى المهني لأطفال برج السرطان.
على الرغم من الانتقادات ، سوف تتقدم باحتراف وقد تسعى إلى تحسين البيئة المهنية الخاصة بك
في أكثر من موقع واتجاه واحد في نفس الوقت. معظم الوقت ستحرز تقدمًا ممتازًا إما عن طريق الترقية إلى موضع أعلى
أو سيكون هناك بعض العروض المقترحة في الغالب خلال شهر مارس يجب تحذيرها
من القرارات والتفكير الكثير قبل اتخاذها ، وخاصة مارس ويونيو ، فإن العمل لن يعطيك كل ما تريد`,
            4: `
الحب يطرق مرة أخرى ، لذلك يجب الاستفادة من الفرص التي منحته بشكل جيد.
الابتعاد عن تحليل الأمور والدخول في التفاصيل في علاقتك مع شريك حياتك ، وخاصة إذا كانت العلاقة متوترة.
ستحدد علاقتك مع الشريك إما عن طريق الاستمرار أو إنهاء العلاقة.
أبواب الزواج مفتوحة على مصراعيها ، وينتظر حفل الزفاف لأبناء هذا البرج هذا العام
. أما بالنسبة للمتزوج ، فإن الحياة تسير بينهما دون مشاكل في معظم الأحيان وفهم بعضنا البعض`,
            5: `سيكون هناك تطورات جيدة للغاية على المستوى المهني لأطفال برج السرطان.
على الرغم من الانتقادات ، سوف تتقدم باحتراف وقد تسعى إلى تحسين البيئة المهنية الخاصة بك
في أكثر من موقع واتجاه واحد في نفس الوقت. معظم الوقت ستحرز تقدمًا ممتازًا إما عن طريق الترقية إلى موضع أعلى
أو سيكون هناك بعض العروض المقترحة في الغالب خلال شهر مارس يجب تحذيرها
من القرارات والتفكير الكثير قبل اتخاذها ، وخاصة مارس ويونيو ، فإن العمل لن يعطيك كل ما تريد`,
            6: `
الحب يطرق مرة أخرى ، لذلك يجب الاستفادة من الفرص التي منحته بشكل جيد.
الابتعاد عن تحليل الأمور والدخول في التفاصيل في علاقتك مع شريك حياتك ، وخاصة إذا كانت العلاقة متوترة.
ستحدد علاقتك مع الشريك إما عن طريق الاستمرار أو إنهاء العلاقة.
أبواب الزواج مفتوحة على مصراعيها ، وينتظر حفل الزفاف لأبناء هذا البرج هذا العام
. أما بالنسبة للمتزوج ، فإن الحياة تسير بينهما دون مشاكل في معظم الأحيان وفهم بعضنا البعض`,
            7: `سيكون هناك تطورات جيدة للغاية على المستوى المهني لأطفال برج السرطان.
على الرغم من الانتقادات ، سوف تتقدم باحتراف وقد تسعى إلى تحسين البيئة المهنية الخاصة بك
في أكثر من موقع واتجاه واحد في نفس الوقت. معظم الوقت ستحرز تقدمًا ممتازًا إما عن طريق الترقية إلى موضع أعلى
أو سيكون هناك بعض العروض المقترحة في الغالب خلال شهر مارس يجب تحذيرها
من القرارات والتفكير الكثير قبل اتخاذها ، وخاصة مارس ويونيو ، فإن العمل لن يعطيك كل ما تريد`,
            8: `
الحب يطرق مرة أخرى ، لذلك يجب الاستفادة من الفرص التي منحته بشكل جيد.
الابتعاد عن تحليل الأمور والدخول في التفاصيل في علاقتك مع شريك حياتك ، وخاصة إذا كانت العلاقة متوترة.
ستحدد علاقتك مع الشريك إما عن طريق الاستمرار أو إنهاء العلاقة.
أبواب الزواج مفتوحة على مصراعيها ، وينتظر حفل الزفاف لأبناء هذا البرج هذا العام
. أما بالنسبة للمتزوج ، فإن الحياة تسير بينهما دون مشاكل في معظم الأحيان وفهم بعضنا البعض`,
            9: `سيكون هناك تطورات جيدة للغاية على المستوى المهني لأطفال برج السرطان.
على الرغم من الانتقادات ، سوف تتقدم باحتراف وقد تسعى إلى تحسين البيئة المهنية الخاصة بك
في أكثر من موقع واتجاه واحد في نفس الوقت. معظم الوقت ستحرز تقدمًا ممتازًا إما عن طريق الترقية إلى موضع أعلى
أو سيكون هناك بعض العروض المقترحة في الغالب خلال شهر مارس يجب تحذيرها
من القرارات والتفكير الكثير قبل اتخاذها ، وخاصة مارس ويونيو ، فإن العمل لن يعطيك كل ما تريد`,
            31: `
الحب يطرق مرة أخرى ، لذلك يجب الاستفادة من الفرص التي منحته بشكل جيد.
الابتعاد عن تحليل الأمور والدخول في التفاصيل في علاقتك مع شريك حياتك ، وخاصة إذا كانت العلاقة متوترة.
ستحدد علاقتك مع الشريك إما عن طريق الاستمرار أو إنهاء العلاقة.
أبواب الزواج مفتوحة على مصراعيها ، وينتظر حفل الزفاف لأبناء هذا البرج هذا العام
. أما بالنسبة للمتزوج ، فإن الحياة تسير بينهما دون مشاكل في معظم الأحيان وفهم بعضنا البعض`,
            
        }

    },
    'الأسد': {

        sun_sign: {
            0: `وفقا لبرجك ، سيكون أبراج ساتورن وجوبيتير في أفضل وضع لهم خلال هذه الفترة ، والذي سينعكس بشكل إيجابي. أنت
ستشهد تغييرات جذرية في حياتك المهنية وقد تناقش عقدًا جديدًا بموجب شروطك.
2020 سيكون عامًا واعدًا لك على المستوى المهني وستحصد ثمار عملك الجاد. إنها نقطة التحول
في حياتك المهنية`,
            1: `2020 هو وقت رائع لتزدهر علاقتك العاطفية ، وسوف تدرك أنك تريد علاقة مريحة. يمكنك محاولة فتح صفحة جديدة أو تصحيح موقفك العاطفي مع شريك حياتك ،
خاصة بعد مواجهة بعض الخلافات والخلافات معه.
تخبرك التوقعات أنه يمكنك السفر والتخطيط لرحلة ممتعة خلال شهري مارس وأبريل.
خلال هذه الفترة ، يجب عليك محاولة الاقتراب من شريك حياتك وتعزيز علاقتك العاطفية مع شريك حياتك`,
            2: `وفقا لبرجك ، سيكون أبراج ساتورن وجوبيتير في أفضل وضع لهم خلال هذه الفترة ، والذي سينعكس بشكل إيجابي. أنت
ستشهد تغييرات جذرية في حياتك المهنية وقد تناقش عقدًا جديدًا بموجب شروطك.
2020 سيكون عامًا واعدًا لك على المستوى المهني وستحصد ثمار عملك الجاد. إنها نقطة التحول
في حياتك المهنية`,
            3: `2020 هو وقت رائع لتزدهر علاقتك العاطفية ، وسوف تدرك أنك تريد علاقة مريحة. يمكنك محاولة فتح صفحة جديدة أو تصحيح موقفك العاطفي مع شريك حياتك ،
خاصة بعد مواجهة بعض الخلافات والخلافات معه.
تخبرك التوقعات أنه يمكنك السفر والتخطيط لرحلة ممتعة خلال شهري مارس وأبريل.
خلال هذه الفترة ، يجب عليك محاولة الاقتراب من شريك حياتك وتعزيز علاقتك العاطفية مع شريك حياتك`,
            4: `وفقا لبرجك ، سيكون أبراج ساتورن وجوبيتير في أفضل وضع لهم خلال هذه الفترة ، والذي سينعكس بشكل إيجابي. أنت
ستشهد تغييرات جذرية في حياتك المهنية وقد تناقش عقدًا جديدًا بموجب شروطك.
2020 سيكون عامًا واعدًا لك على المستوى المهني وستحصد ثمار عملك الجاد. إنها نقطة التحول
في حياتك المهنية`,
            5: `2020 هو وقت رائع لتزدهر علاقتك العاطفية ، وسوف تدرك أنك تريد علاقة مريحة. يمكنك محاولة فتح صفحة جديدة أو تصحيح موقفك العاطفي مع شريك حياتك ،
خاصة بعد مواجهة بعض الخلافات والخلافات معه.
تخبرك التوقعات أنه يمكنك السفر والتخطيط لرحلة ممتعة خلال شهري مارس وأبريل.
خلال هذه الفترة ، يجب عليك محاولة الاقتراب من شريك حياتك وتعزيز علاقتك العاطفية مع شريك حياتك`,
            6: `وفقا لبرجك ، سيكون أبراج ساتورن وجوبيتير في أفضل وضع لهم خلال هذه الفترة ، والذي سينعكس بشكل إيجابي. أنت
ستشهد تغييرات جذرية في حياتك المهنية وقد تناقش عقدًا جديدًا بموجب شروطك.
2020 سيكون عامًا واعدًا لك على المستوى المهني وستحصد ثمار عملك الجاد. إنها نقطة التحول
في حياتك المهنية`,
            7: `2020 هو وقت رائع لتزدهر علاقتك العاطفية ، وسوف تدرك أنك تريد علاقة مريحة. يمكنك محاولة فتح صفحة جديدة أو تصحيح موقفك العاطفي مع شريك حياتك ،
خاصة بعد مواجهة بعض الخلافات والخلافات معه.
تخبرك التوقعات أنه يمكنك السفر والتخطيط لرحلة ممتعة خلال شهري مارس وأبريل.
خلال هذه الفترة ، يجب عليك محاولة الاقتراب من شريك حياتك وتعزيز علاقتك العاطفية مع شريك حياتك`,
            8: `وفقا لبرجك ، سيكون أبراج ساتورن وجوبيتير في أفضل وضع لهم خلال هذه الفترة ، والذي سينعكس بشكل إيجابي. أنت
ستشهد تغييرات جذرية في حياتك المهنية وقد تناقش عقدًا جديدًا بموجب شروطك.
2020 سيكون عامًا واعدًا لك على المستوى المهني وستحصد ثمار عملك الجاد. إنها نقطة التحول
في حياتك المهنية`,
            9: `2020 هو وقت رائع لتزدهر علاقتك العاطفية ، وسوف تدرك أنك تريد علاقة مريحة. يمكنك محاولة فتح صفحة جديدة أو تصحيح موقفك العاطفي مع شريك حياتك ،
خاصة بعد مواجهة بعض الخلافات والخلافات معه.
تخبرك التوقعات أنه يمكنك السفر والتخطيط لرحلة ممتعة خلال شهري مارس وأبريل.
خلال هذه الفترة ، يجب عليك محاولة الاقتراب من شريك حياتك وتعزيز علاقتك العاطفية مع شريك حياتك`,
            31: `وفقا لبرجك ، سيكون أبراج ساتورن وجوبيتير في أفضل وضع لهم خلال هذه الفترة ، والذي سينعكس بشكل إيجابي. أنت
ستشهد تغييرات جذرية في حياتك المهنية وقد تناقش عقدًا جديدًا بموجب شروطك.
2020 سيكون عامًا واعدًا لك على المستوى المهني وستحصد ثمار عملك الجاد. إنها نقطة التحول
في حياتك المهنية`,
           
        }
    },
    'برج العذراء': {
        sun_sign: {
            0: `إذا كنت في علاقة ، سترى بعض التوترات والمشاجرات مع شريكك ،
مما يجعلك تعيش في حالة من عدم الاستقرار ، بسبب تدخلات البعض
ولكنك ستستمتع بالاستقرار العاطفي بحلول شهر فبراير ، وإذا كنت متحررا من القلب ستجد الحب يطرق بابك
صيف منتصف شهر يوليو حتى منتصف سبتمبر ، يتغير وضعك الاجتماعي نحو الأفضل وتواجهه
مفاجأة غير متوقعة أنك لم تفكر`,
            1: `وتتوقع المغربية والفلكية اللبنانية ماجي فرح عام 2020
تبدأ في بداية ارتباك معين. تجد قلقك أو عدم الحرية. تشعر أنك تسير في الاتجاه الخاطئ والذهاب
من خلال الظروف الصعبة. لكن عليك التحلي بالصبر. مارس 2020
حيث الهدوء والطمأنينة والسعادة حيث تشعر بقدراتك ، وتحقيق انتصارات مهمة على المستوى المهني
وفجأة وبشكل غير متوقع وسوف تجد من الذي يدعمك من الثقة وتوسيع دائرة علاقاتك`,
            2: `إذا كنت في علاقة ، سترى بعض التوترات والمشاجرات مع شريكك ،
مما يجعلك تعيش في حالة من عدم الاستقرار ، بسبب تدخلات البعض
ولكنك ستستمتع بالاستقرار العاطفي بحلول شهر فبراير ، وإذا كنت متحررا من القلب ستجد الحب يطرق بابك
صيف منتصف شهر يوليو حتى منتصف سبتمبر ، يتغير وضعك الاجتماعي نحو الأفضل وتواجهه
مفاجأة غير متوقعة أنك لم تفكر`,
            3: `وتتوقع المغربية والفلكية اللبنانية ماجي فرح عام 2020
تبدأ في بداية ارتباك معين. تجد قلقك أو عدم الحرية. تشعر أنك تسير في الاتجاه الخاطئ والذهاب
من خلال الظروف الصعبة. لكن عليك التحلي بالصبر. مارس 2020
حيث الهدوء والطمأنينة والسعادة حيث تشعر بقدراتك ، وتحقيق انتصارات مهمة على المستوى المهني
وفجأة وبشكل غير متوقع وسوف تجد من الذي يدعمك من الثقة وتوسيع دائرة علاقاتك`,
            4: `إذا كنت في علاقة ، سترى بعض التوترات والمشاجرات مع شريكك ،
مما يجعلك تعيش في حالة من عدم الاستقرار ، بسبب تدخلات البعض
ولكنك ستستمتع بالاستقرار العاطفي بحلول شهر فبراير ، وإذا كنت متحررا من القلب ستجد الحب يطرق بابك
صيف منتصف شهر يوليو حتى منتصف سبتمبر ، يتغير وضعك الاجتماعي نحو الأفضل وتواجهه
مفاجأة غير متوقعة أنك لم تفكر`,
            5: `وتتوقع المغربية والفلكية اللبنانية ماجي فرح عام 2020
تبدأ في بداية ارتباك معين. تجد قلقك أو عدم الحرية. تشعر أنك تسير في الاتجاه الخاطئ والذهاب
من خلال الظروف الصعبة. لكن عليك التحلي بالصبر. مارس 2020
حيث الهدوء والطمأنينة والسعادة حيث تشعر بقدراتك ، وتحقيق انتصارات مهمة على المستوى المهني
وفجأة وبشكل غير متوقع وسوف تجد من الذي يدعمك من الثقة وتوسيع دائرة علاقاتك`,
            6: `إذا كنت في علاقة ، سترى بعض التوترات والمشاجرات مع شريكك ،
مما يجعلك تعيش في حالة من عدم الاستقرار ، بسبب تدخلات البعض
ولكنك ستستمتع بالاستقرار العاطفي بحلول شهر فبراير ، وإذا كنت متحررا من القلب ستجد الحب يطرق بابك
صيف منتصف شهر يوليو حتى منتصف سبتمبر ، يتغير وضعك الاجتماعي نحو الأفضل وتواجهه
مفاجأة غير متوقعة أنك لم تفكر`,
            7: `وتتوقع المغربية والفلكية اللبنانية ماجي فرح عام 2020
تبدأ في بداية ارتباك معين. تجد قلقك أو عدم الحرية. تشعر أنك تسير في الاتجاه الخاطئ والذهاب
من خلال الظروف الصعبة. لكن عليك التحلي بالصبر. مارس 2020
حيث الهدوء والطمأنينة والسعادة حيث تشعر بقدراتك ، وتحقيق انتصارات مهمة على المستوى المهني
وفجأة وبشكل غير متوقع وسوف تجد من الذي يدعمك من الثقة وتوسيع دائرة علاقاتك`,
            8: `إذا كنت في علاقة ، سترى بعض التوترات والمشاجرات مع شريكك ،
مما يجعلك تعيش في حالة من عدم الاستقرار ، بسبب تدخلات البعض
ولكنك ستستمتع بالاستقرار العاطفي بحلول شهر فبراير ، وإذا كنت متحررا من القلب ستجد الحب يطرق بابك
صيف منتصف شهر يوليو حتى منتصف سبتمبر ، يتغير وضعك الاجتماعي نحو الأفضل وتواجهه
مفاجأة غير متوقعة أنك لم تفكر`,
            9: `وتتوقع المغربية والفلكية اللبنانية ماجي فرح عام 2020
تبدأ في بداية ارتباك معين. تجد قلقك أو عدم الحرية. تشعر أنك تسير في الاتجاه الخاطئ والذهاب
من خلال الظروف الصعبة. لكن عليك التحلي بالصبر. مارس 2020
حيث الهدوء والطمأنينة والسعادة حيث تشعر بقدراتك ، وتحقيق انتصارات مهمة على المستوى المهني
وفجأة وبشكل غير متوقع وسوف تجد من الذي يدعمك من الثقة وتوسيع دائرة علاقاتك`,
            31: `إذا كنت في علاقة ، سترى بعض التوترات والمشاجرات مع شريكك ،
مما يجعلك تعيش في حالة من عدم الاستقرار ، بسبب تدخلات البعض
ولكنك ستستمتع بالاستقرار العاطفي بحلول شهر فبراير ، وإذا كنت متحررا من القلب ستجد الحب يطرق بابك
صيف منتصف شهر يوليو حتى منتصف سبتمبر ، يتغير وضعك الاجتماعي نحو الأفضل وتواجهه
مفاجأة غير متوقعة أنك لم تفكر`,
            
        }
    },
    'برج الميزان': {
        sun_sign: {
            0: `مرحلة رومانسية  في أواخر أبريل
و  التي يرجع تاريخها منطقة  "المريخ" - و "أورانوس"
منطقة عالية التطاير في فبراير ، والتي قد يكون لها تداعيات كبيرة جدًا ،
ويحدد "كوكب أورانوس" كوكب الصدمة ، في منطقة الألفة في أوائل مارس ،
العديد من الاختلافات والغيرة يمكن أن تكون مميزة لأي علاقة.

إذا كنت ترغب في استعادة السلام في علاقة موجودة ، فإن بداية شهر أبريل هي أفضل وقت لذلك ،
مع القمر الجديد في منطقة الحب ، مما يسمح ببداية جديدة إذا أرادت الأطراف ذلك بالفعل.
إذا كنت عزباء ، فإن أوائل شهر أبريل تكون مناسبة عندما تقابل الغريبة في بداية الربيع
في ترتيب أكثر حساسية. أي علاقة تشكلت في هذا الوقت سوف تمر
منتصف أكتوبر. في الخريف ، يصل كل من الزهرة والمريخ إلى التوازن بينهما
في منتصف سبتمبر وأوائل أكتوبر لمطالبتك بإعادة تقييم ما تريد من علاقة غرامية ، أنت
سوف تبدأ في المطالبة بالاحترام الذي تستحقه`,
            1: `لوصول إلى برجك. عليك أن تعرف أن خياراتك المهنية ستكون محدودة بسبب
بعض من أصعب الظروف التي يجب تجاهلها ، مثل المؤهلات المهنية الضعيفة أو العمر أو حتى المكان الذي تعيش فيه.
إن القرار الذي ستتخذه في أوائل شهر مارس سيعكس كل المقاييس ويعطيك
اختيارات أخرى. يجب أن تستفيد من جميع الفرص لتطوير مستواك المهني والمادّي قبل نهاية العام.

احترس من كسوف الشمس في منطقة حياتك المهنية في أوائل شهر يوليو -
قد تكون هناك مفاجأة كبيرة ، وهذا قد يأتي إليك كصدمة في ذلك الوقت
ولكنها ستكون في مصلحة على المدى الطويل`,
            2: `مرحلة رومانسية  في أواخر أبريل
و  التي يرجع تاريخها منطقة  "المريخ" - و "أورانوس"
منطقة عالية التطاير في فبراير ، والتي قد يكون لها تداعيات كبيرة جدًا ،
ويحدد "كوكب أورانوس" كوكب الصدمة ، في منطقة الألفة في أوائل مارس ،
العديد من الاختلافات والغيرة يمكن أن تكون مميزة لأي علاقة.

إذا كنت ترغب في استعادة السلام في علاقة موجودة ، فإن بداية شهر أبريل هي أفضل وقت لذلك ،
مع القمر الجديد في منطقة الحب ، مما يسمح ببداية جديدة إذا أرادت الأطراف ذلك بالفعل.
إذا كنت عزباء ، فإن أوائل شهر أبريل تكون مناسبة عندما تقابل الغريبة في بداية الربيع
في ترتيب أكثر حساسية. أي علاقة تشكلت في هذا الوقت سوف تمر
منتصف أكتوبر. في الخريف ، يصل كل من الزهرة والمريخ إلى التوازن بينهما
في منتصف سبتمبر وأوائل أكتوبر لمطالبتك بإعادة تقييم ما تريد من علاقة غرامية ، أنت
سوف تبدأ في المطالبة بالاحترام الذي تستحقه`,
            3: `لوصول إلى برجك. عليك أن تعرف أن خياراتك المهنية ستكون محدودة بسبب
بعض من أصعب الظروف التي يجب تجاهلها ، مثل المؤهلات المهنية الضعيفة أو العمر أو حتى المكان الذي تعيش فيه.
إن القرار الذي ستتخذه في أوائل شهر مارس سيعكس كل المقاييس ويعطيك
اختيارات أخرى. يجب أن تستفيد من جميع الفرص لتطوير مستواك المهني والمادّي قبل نهاية العام.

احترس من كسوف الشمس في منطقة حياتك المهنية في أوائل شهر يوليو -
قد تكون هناك مفاجأة كبيرة ، وهذا قد يأتي إليك كصدمة في ذلك الوقت
ولكنها ستكون في مصلحة على المدى الطويل`,
            4: `مرحلة رومانسية  في أواخر أبريل
و  التي يرجع تاريخها منطقة  "المريخ" - و "أورانوس"
منطقة عالية التطاير في فبراير ، والتي قد يكون لها تداعيات كبيرة جدًا ،
ويحدد "كوكب أورانوس" كوكب الصدمة ، في منطقة الألفة في أوائل مارس ،
العديد من الاختلافات والغيرة يمكن أن تكون مميزة لأي علاقة.

إذا كنت ترغب في استعادة السلام في علاقة موجودة ، فإن بداية شهر أبريل هي أفضل وقت لذلك ،
مع القمر الجديد في منطقة الحب ، مما يسمح ببداية جديدة إذا أرادت الأطراف ذلك بالفعل.
إذا كنت عزباء ، فإن أوائل شهر أبريل تكون مناسبة عندما تقابل الغريبة في بداية الربيع
في ترتيب أكثر حساسية. أي علاقة تشكلت في هذا الوقت سوف تمر
منتصف أكتوبر. في الخريف ، يصل كل من الزهرة والمريخ إلى التوازن بينهما
في منتصف سبتمبر وأوائل أكتوبر لمطالبتك بإعادة تقييم ما تريد من علاقة غرامية ، أنت
سوف تبدأ في المطالبة بالاحترام الذي تستحقه`,
            5: `لوصول إلى برجك. عليك أن تعرف أن خياراتك المهنية ستكون محدودة بسبب
بعض من أصعب الظروف التي يجب تجاهلها ، مثل المؤهلات المهنية الضعيفة أو العمر أو حتى المكان الذي تعيش فيه.
إن القرار الذي ستتخذه في أوائل شهر مارس سيعكس كل المقاييس ويعطيك
اختيارات أخرى. يجب أن تستفيد من جميع الفرص لتطوير مستواك المهني والمادّي قبل نهاية العام.

احترس من كسوف الشمس في منطقة حياتك المهنية في أوائل شهر يوليو -
قد تكون هناك مفاجأة كبيرة ، وهذا قد يأتي إليك كصدمة في ذلك الوقت
ولكنها ستكون في مصلحة على المدى الطويل`,
            6: `مرحلة رومانسية  في أواخر أبريل
و  التي يرجع تاريخها منطقة  "المريخ" - و "أورانوس"
منطقة عالية التطاير في فبراير ، والتي قد يكون لها تداعيات كبيرة جدًا ،
ويحدد "كوكب أورانوس" كوكب الصدمة ، في منطقة الألفة في أوائل مارس ،
العديد من الاختلافات والغيرة يمكن أن تكون مميزة لأي علاقة.

إذا كنت ترغب في استعادة السلام في علاقة موجودة ، فإن بداية شهر أبريل هي أفضل وقت لذلك ،
مع القمر الجديد في منطقة الحب ، مما يسمح ببداية جديدة إذا أرادت الأطراف ذلك بالفعل.
إذا كنت عزباء ، فإن أوائل شهر أبريل تكون مناسبة عندما تقابل الغريبة في بداية الربيع
في ترتيب أكثر حساسية. أي علاقة تشكلت في هذا الوقت سوف تمر
منتصف أكتوبر. في الخريف ، يصل كل من الزهرة والمريخ إلى التوازن بينهما
في منتصف سبتمبر وأوائل أكتوبر لمطالبتك بإعادة تقييم ما تريد من علاقة غرامية ، أنت
سوف تبدأ في المطالبة بالاحترام الذي تستحقه`,
            7: `لوصول إلى برجك. عليك أن تعرف أن خياراتك المهنية ستكون محدودة بسبب
بعض من أصعب الظروف التي يجب تجاهلها ، مثل المؤهلات المهنية الضعيفة أو العمر أو حتى المكان الذي تعيش فيه.
إن القرار الذي ستتخذه في أوائل شهر مارس سيعكس كل المقاييس ويعطيك
اختيارات أخرى. يجب أن تستفيد من جميع الفرص لتطوير مستواك المهني والمادّي قبل نهاية العام.

احترس من كسوف الشمس في منطقة حياتك المهنية في أوائل شهر يوليو -
قد تكون هناك مفاجأة كبيرة ، وهذا قد يأتي إليك كصدمة في ذلك الوقت
ولكنها ستكون في مصلحة على المدى الطويل`,
            8: `مرحلة رومانسية  في أواخر أبريل
و  التي يرجع تاريخها منطقة  "المريخ" - و "أورانوس"
منطقة عالية التطاير في فبراير ، والتي قد يكون لها تداعيات كبيرة جدًا ،
ويحدد "كوكب أورانوس" كوكب الصدمة ، في منطقة الألفة في أوائل مارس ،
العديد من الاختلافات والغيرة يمكن أن تكون مميزة لأي علاقة.

إذا كنت ترغب في استعادة السلام في علاقة موجودة ، فإن بداية شهر أبريل هي أفضل وقت لذلك ،
مع القمر الجديد في منطقة الحب ، مما يسمح ببداية جديدة إذا أرادت الأطراف ذلك بالفعل.
إذا كنت عزباء ، فإن أوائل شهر أبريل تكون مناسبة عندما تقابل الغريبة في بداية الربيع
في ترتيب أكثر حساسية. أي علاقة تشكلت في هذا الوقت سوف تمر
منتصف أكتوبر. في الخريف ، يصل كل من الزهرة والمريخ إلى التوازن بينهما
في منتصف سبتمبر وأوائل أكتوبر لمطالبتك بإعادة تقييم ما تريد من علاقة غرامية ، أنت
سوف تبدأ في المطالبة بالاحترام الذي تستحقه`,
            9: `لوصول إلى برجك. عليك أن تعرف أن خياراتك المهنية ستكون محدودة بسبب
بعض من أصعب الظروف التي يجب تجاهلها ، مثل المؤهلات المهنية الضعيفة أو العمر أو حتى المكان الذي تعيش فيه.
إن القرار الذي ستتخذه في أوائل شهر مارس سيعكس كل المقاييس ويعطيك
اختيارات أخرى. يجب أن تستفيد من جميع الفرص لتطوير مستواك المهني والمادّي قبل نهاية العام.

احترس من كسوف الشمس في منطقة حياتك المهنية في أوائل شهر يوليو -
قد تكون هناك مفاجأة كبيرة ، وهذا قد يأتي إليك كصدمة في ذلك الوقت
ولكنها ستكون في مصلحة على المدى الطويل`,
            31: `مرحلة رومانسية  في أواخر أبريل
و  التي يرجع تاريخها منطقة  "المريخ" - و "أورانوس"
منطقة عالية التطاير في فبراير ، والتي قد يكون لها تداعيات كبيرة جدًا ،
ويحدد "كوكب أورانوس" كوكب الصدمة ، في منطقة الألفة في أوائل مارس ،
العديد من الاختلافات والغيرة يمكن أن تكون مميزة لأي علاقة.

إذا كنت ترغب في استعادة السلام في علاقة موجودة ، فإن بداية شهر أبريل هي أفضل وقت لذلك ،
مع القمر الجديد في منطقة الحب ، مما يسمح ببداية جديدة إذا أرادت الأطراف ذلك بالفعل.
إذا كنت عزباء ، فإن أوائل شهر أبريل تكون مناسبة عندما تقابل الغريبة في بداية الربيع
في ترتيب أكثر حساسية. أي علاقة تشكلت في هذا الوقت سوف تمر
منتصف أكتوبر. في الخريف ، يصل كل من الزهرة والمريخ إلى التوازن بينهما
في منتصف سبتمبر وأوائل أكتوبر لمطالبتك بإعادة تقييم ما تريد من علاقة غرامية ، أنت
سوف تبدأ في المطالبة بالاحترام الذي تستحقه`,
            
        }
    },
    'العقرب': {
        sun_sign: {
            0: `سيزور برج العقرب 2020 فينوس وتنبأ المريخ
أنه سيكون عامًا مثاليًا لعقرب العقرب
الجزء الأول من عام 2020 سوف يسير على ما يرام ، إذا كنت تشارك بالفعل في العلاقة ، سوف تستمتع بالحب والهدوء و
الكثير من المودة مع شريك الحياة.
سواء كنت عازبًا أو في علاقة حب ، يتم تحديد فرص المشاركة الرسمية في خططك عام 2020 ،
لكن الأبراج تنصح بعدم الزواج خلال يناير وفبراير.
الحب سيكون في ذروته في بقية الأشهر ، ولكن قد تزيد الاختلافات في الأشهر الأولى من السنة.
قد تصادف بعض المغامرات في فبراير ، إذا لم تقم بإلغائها ، فسوف تصادف الحب الحقيقي`,
            1: `تخبرك ماجي فرح أنك ستتمكن من التخلص من العقبات المالية التي واجهتها في العام الماضي
وستعتمد المالية لهذا العام على كيفية تعاملك مع المال. إذا كنت تستثمر المال بين 4 و 7 أبريل
ومن 1 إلى 13 مايو لا يكون هذا الوقت المناسب للإنفاق المالي الكبير
حاول أن تكون أكثر حذراً في التخطيط الجيد لميزانيتك والحد من نفقاتك
وإلا قد ينتهي بك الأمر مع القليل من المال أو عدم وجود أموال لحالات الطوارئ.
ستكون الفترة من سبتمبر إلى نهاية العام هي الأفضل على المستوى المالي`,
            2: `سيزور برج العقرب 2020 فينوس وتنبأ المريخ
أنه سيكون عامًا مثاليًا لعقرب العقرب
الجزء الأول من عام 2020 سوف يسير على ما يرام ، إذا كنت تشارك بالفعل في العلاقة ، سوف تستمتع بالحب والهدوء و
الكثير من المودة مع شريك الحياة.
سواء كنت عازبًا أو في علاقة حب ، يتم تحديد فرص المشاركة الرسمية في خططك عام 2020 ،
لكن الأبراج تنصح بعدم الزواج خلال يناير وفبراير.
الحب سيكون في ذروته في بقية الأشهر ، ولكن قد تزيد الاختلافات في الأشهر الأولى من السنة.
قد تصادف بعض المغامرات في فبراير ، إذا لم تقم بإلغائها ، فسوف تصادف الحب الحقيقي`,
            3: `تخبرك ماجي فرح أنك ستتمكن من التخلص من العقبات المالية التي واجهتها في العام الماضي
وستعتمد المالية لهذا العام على كيفية تعاملك مع المال. إذا كنت تستثمر المال بين 4 و 7 أبريل
ومن 1 إلى 13 مايو لا يكون هذا الوقت المناسب للإنفاق المالي الكبير
حاول أن تكون أكثر حذراً في التخطيط الجيد لميزانيتك والحد من نفقاتك
وإلا قد ينتهي بك الأمر مع القليل من المال أو عدم وجود أموال لحالات الطوارئ.
ستكون الفترة من سبتمبر إلى نهاية العام هي الأفضل على المستوى المالي`,
            4: `سيزور برج العقرب 2020 فينوس وتنبأ المريخ
أنه سيكون عامًا مثاليًا لعقرب العقرب
الجزء الأول من عام 2020 سوف يسير على ما يرام ، إذا كنت تشارك بالفعل في العلاقة ، سوف تستمتع بالحب والهدوء و
الكثير من المودة مع شريك الحياة.
سواء كنت عازبًا أو في علاقة حب ، يتم تحديد فرص المشاركة الرسمية في خططك عام 2020 ،
لكن الأبراج تنصح بعدم الزواج خلال يناير وفبراير.
الحب سيكون في ذروته في بقية الأشهر ، ولكن قد تزيد الاختلافات في الأشهر الأولى من السنة.
قد تصادف بعض المغامرات في فبراير ، إذا لم تقم بإلغائها ، فسوف تصادف الحب الحقيقي`,
            5: `تخبرك ماجي فرح أنك ستتمكن من التخلص من العقبات المالية التي واجهتها في العام الماضي
وستعتمد المالية لهذا العام على كيفية تعاملك مع المال. إذا كنت تستثمر المال بين 4 و 7 أبريل
ومن 1 إلى 13 مايو لا يكون هذا الوقت المناسب للإنفاق المالي الكبير
حاول أن تكون أكثر حذراً في التخطيط الجيد لميزانيتك والحد من نفقاتك
وإلا قد ينتهي بك الأمر مع القليل من المال أو عدم وجود أموال لحالات الطوارئ.
ستكون الفترة من سبتمبر إلى نهاية العام هي الأفضل على المستوى المالي`,
            6: `سيزور برج العقرب 2020 فينوس وتنبأ المريخ
أنه سيكون عامًا مثاليًا لعقرب العقرب
الجزء الأول من عام 2020 سوف يسير على ما يرام ، إذا كنت تشارك بالفعل في العلاقة ، سوف تستمتع بالحب والهدوء و
الكثير من المودة مع شريك الحياة.
سواء كنت عازبًا أو في علاقة حب ، يتم تحديد فرص المشاركة الرسمية في خططك عام 2020 ،
لكن الأبراج تنصح بعدم الزواج خلال يناير وفبراير.
الحب سيكون في ذروته في بقية الأشهر ، ولكن قد تزيد الاختلافات في الأشهر الأولى من السنة.
قد تصادف بعض المغامرات في فبراير ، إذا لم تقم بإلغائها ، فسوف تصادف الحب الحقيقي`,
            7: `تخبرك ماجي فرح أنك ستتمكن من التخلص من العقبات المالية التي واجهتها في العام الماضي
وستعتمد المالية لهذا العام على كيفية تعاملك مع المال. إذا كنت تستثمر المال بين 4 و 7 أبريل
ومن 1 إلى 13 مايو لا يكون هذا الوقت المناسب للإنفاق المالي الكبير
حاول أن تكون أكثر حذراً في التخطيط الجيد لميزانيتك والحد من نفقاتك
وإلا قد ينتهي بك الأمر مع القليل من المال أو عدم وجود أموال لحالات الطوارئ.
ستكون الفترة من سبتمبر إلى نهاية العام هي الأفضل على المستوى المالي`,
            8: `سيزور برج العقرب 2020 فينوس وتنبأ المريخ
أنه سيكون عامًا مثاليًا لعقرب العقرب
الجزء الأول من عام 2020 سوف يسير على ما يرام ، إذا كنت تشارك بالفعل في العلاقة ، سوف تستمتع بالحب والهدوء و
الكثير من المودة مع شريك الحياة.
سواء كنت عازبًا أو في علاقة حب ، يتم تحديد فرص المشاركة الرسمية في خططك عام 2020 ،
لكن الأبراج تنصح بعدم الزواج خلال يناير وفبراير.
الحب سيكون في ذروته في بقية الأشهر ، ولكن قد تزيد الاختلافات في الأشهر الأولى من السنة.
قد تصادف بعض المغامرات في فبراير ، إذا لم تقم بإلغائها ، فسوف تصادف الحب الحقيقي`,
            9: `تخبرك ماجي فرح أنك ستتمكن من التخلص من العقبات المالية التي واجهتها في العام الماضي
وستعتمد المالية لهذا العام على كيفية تعاملك مع المال. إذا كنت تستثمر المال بين 4 و 7 أبريل
ومن 1 إلى 13 مايو لا يكون هذا الوقت المناسب للإنفاق المالي الكبير
حاول أن تكون أكثر حذراً في التخطيط الجيد لميزانيتك والحد من نفقاتك
وإلا قد ينتهي بك الأمر مع القليل من المال أو عدم وجود أموال لحالات الطوارئ.
ستكون الفترة من سبتمبر إلى نهاية العام هي الأفضل على المستوى المالي`,
            31: `سيزور برج العقرب 2020 فينوس وتنبأ المريخ
أنه سيكون عامًا مثاليًا لعقرب العقرب
الجزء الأول من عام 2020 سوف يسير على ما يرام ، إذا كنت تشارك بالفعل في العلاقة ، سوف تستمتع بالحب والهدوء و
الكثير من المودة مع شريك الحياة.
سواء كنت عازبًا أو في علاقة حب ، يتم تحديد فرص المشاركة الرسمية في خططك عام 2020 ،
لكن الأبراج تنصح بعدم الزواج خلال يناير وفبراير.
الحب سيكون في ذروته في بقية الأشهر ، ولكن قد تزيد الاختلافات في الأشهر الأولى من السنة.
قد تصادف بعض المغامرات في فبراير ، إذا لم تقم بإلغائها ، فسوف تصادف الحب الحقيقي`,
            
        }
    },
    'القوس': {
        sun_sign: {
            0: `ويتوقع الفلكي والمجرمة اللبنانية ماجي فرح أن يبزغ القوس الجديد في العام الجديد
مع وجود المشتري في القوس ، لذلك سيكون عاما مليئا بالموسيقى والموسيقى الإيجابية ،
الحب والنجاح`,
            1: `قد يتعرض لبعض الانتقادات ويعيش جو مشوش على المستوى المهني. لا تجعل ذلك يؤثر عليك
ويتم تنبيهك من الإهمال وبعض التخلف عن السداد ، يجب عليك أيضًا توخي الحذر من بعض الأشخاص الذين يحاولون حب المؤامرات ضدك
والنيل ، خاصة إذا كنت تعمل في القطاع العام. ولكن ، ستعرف لجذب المؤيدين والداعمين.
ستحصل على الدعم من نافذة شخصية وستنجح في حفظ وضعك المهني.
تعاني من بعض النكسات المالية وبعض الخسائر. قد تضطر إلى طلب المشورة القانونية لحل بعض المشاكل.
ومع ذلك ، فإن وضعك المالي يتحسن وترى انفراجة مالية ترافقك إلى نهاية العام`,
            2: `ويتوقع الفلكي والمجرمة اللبنانية ماجي فرح أن يبزغ القوس الجديد في العام الجديد
مع وجود المشتري في القوس ، لذلك سيكون عاما مليئا بالموسيقى والموسيقى الإيجابية ،
الحب والنجاح`,
            3: `قد يتعرض لبعض الانتقادات ويعيش جو مشوش على المستوى المهني. لا تجعل ذلك يؤثر عليك
ويتم تنبيهك من الإهمال وبعض التخلف عن السداد ، يجب عليك أيضًا توخي الحذر من بعض الأشخاص الذين يحاولون حب المؤامرات ضدك
والنيل ، خاصة إذا كنت تعمل في القطاع العام. ولكن ، ستعرف لجذب المؤيدين والداعمين.
ستحصل على الدعم من نافذة شخصية وستنجح في حفظ وضعك المهني.
تعاني من بعض النكسات المالية وبعض الخسائر. قد تضطر إلى طلب المشورة القانونية لحل بعض المشاكل.
ومع ذلك ، فإن وضعك المالي يتحسن وترى انفراجة مالية ترافقك إلى نهاية العام`,
            4: `ويتوقع الفلكي والمجرمة اللبنانية ماجي فرح أن يبزغ القوس الجديد في العام الجديد
مع وجود المشتري في القوس ، لذلك سيكون عاما مليئا بالموسيقى والموسيقى الإيجابية ،
الحب والنجاح`,
            5: `قد يتعرض لبعض الانتقادات ويعيش جو مشوش على المستوى المهني. لا تجعل ذلك يؤثر عليك
ويتم تنبيهك من الإهمال وبعض التخلف عن السداد ، يجب عليك أيضًا توخي الحذر من بعض الأشخاص الذين يحاولون حب المؤامرات ضدك
والنيل ، خاصة إذا كنت تعمل في القطاع العام. ولكن ، ستعرف لجذب المؤيدين والداعمين.
ستحصل على الدعم من نافذة شخصية وستنجح في حفظ وضعك المهني.
تعاني من بعض النكسات المالية وبعض الخسائر. قد تضطر إلى طلب المشورة القانونية لحل بعض المشاكل.
ومع ذلك ، فإن وضعك المالي يتحسن وترى انفراجة مالية ترافقك إلى نهاية العام`,
            6: `ويتوقع الفلكي والمجرمة اللبنانية ماجي فرح أن يبزغ القوس الجديد في العام الجديد
مع وجود المشتري في القوس ، لذلك سيكون عاما مليئا بالموسيقى والموسيقى الإيجابية ،
الحب والنجاح`,
            7: `قد يتعرض لبعض الانتقادات ويعيش جو مشوش على المستوى المهني. لا تجعل ذلك يؤثر عليك
ويتم تنبيهك من الإهمال وبعض التخلف عن السداد ، يجب عليك أيضًا توخي الحذر من بعض الأشخاص الذين يحاولون حب المؤامرات ضدك
والنيل ، خاصة إذا كنت تعمل في القطاع العام. ولكن ، ستعرف لجذب المؤيدين والداعمين.
ستحصل على الدعم من نافذة شخصية وستنجح في حفظ وضعك المهني.
تعاني من بعض النكسات المالية وبعض الخسائر. قد تضطر إلى طلب المشورة القانونية لحل بعض المشاكل.
ومع ذلك ، فإن وضعك المالي يتحسن وترى انفراجة مالية ترافقك إلى نهاية العام`,
            8: `ويتوقع الفلكي والمجرمة اللبنانية ماجي فرح أن يبزغ القوس الجديد في العام الجديد
مع وجود المشتري في القوس ، لذلك سيكون عاما مليئا بالموسيقى والموسيقى الإيجابية ،
الحب والنجاح`,
            9: `قد يتعرض لبعض الانتقادات ويعيش جو مشوش على المستوى المهني. لا تجعل ذلك يؤثر عليك
ويتم تنبيهك من الإهمال وبعض التخلف عن السداد ، يجب عليك أيضًا توخي الحذر من بعض الأشخاص الذين يحاولون حب المؤامرات ضدك
والنيل ، خاصة إذا كنت تعمل في القطاع العام. ولكن ، ستعرف لجذب المؤيدين والداعمين.
ستحصل على الدعم من نافذة شخصية وستنجح في حفظ وضعك المهني.
تعاني من بعض النكسات المالية وبعض الخسائر. قد تضطر إلى طلب المشورة القانونية لحل بعض المشاكل.
ومع ذلك ، فإن وضعك المالي يتحسن وترى انفراجة مالية ترافقك إلى نهاية العام`,
            31: `ويتوقع الفلكي والمجرمة اللبنانية ماجي فرح أن يبزغ القوس الجديد في العام الجديد
مع وجود المشتري في القوس ، لذلك سيكون عاما مليئا بالموسيقى والموسيقى الإيجابية ،`
        }
    },
    'الجدي': {
        sun_sign:{
            0: `زحل في الكوكب السابع الخاص بك ، والذي يتيح لك إمكانية علاقات جدية
        ويجعلك تأخذ زمام المبادرة في حب شريكك أو مع الأصدقاء واختبار قوة أي علاقة ،
        ولكن في نفس الوقت سيكون عليك تقديم بعض التنازلات وذلك لإرضاء شريكك والحفاظ على علاقتكما معاً.
        قد تنجح في استيعاب الأشياء العاطفية أكثر من قبل`,
            1: `يحمل أطفال الجدي دائماً أفكاراً إبداعية بطريقة ممتازة ، لذلك عليك أن تحاول الحديث عنهم وتسليط الضوء عليهم للجميع
        سوف تجد مساعدة مفيدة والاستماع إليك ، وستكون الأشهر الأولى من عام 2020 جيدة جدًا للانفتاح والعمل والسفر
        أنت فقط لا تكون متشائما أو محبطا مهما حدث`,
            2: `زحل في الكوكب السابع الخاص بك ، والذي يتيح لك إمكانية علاقات جدية
        ويجعلك تأخذ زمام المبادرة في حب شريكك أو مع الأصدقاء واختبار قوة أي علاقة ،
        ولكن في نفس الوقت سيكون عليك تقديم بعض التنازلات وذلك لإرضاء شريكك والحفاظ على علاقتكما معاً.
        قد تنجح في استيعاب الأشياء العاطفية أكثر من قبل`,
            3: `يحمل أطفال الجدي دائماً أفكاراً إبداعية بطريقة ممتازة ، لذلك عليك أن تحاول الحديث عنهم وتسليط الضوء عليهم للجميع
        سوف تجد مساعدة مفيدة والاستماع إليك ، وستكون الأشهر الأولى من عام 2020 جيدة جدًا للانفتاح والعمل والسفر
        أنت فقط لا تكون متشائما أو محبطا مهما حدث`,
            4: `زحل في الكوكب السابع الخاص بك ، والذي يتيح لك إمكانية علاقات جدية
        ويجعلك تأخذ زمام المبادرة في حب شريكك أو مع الأصدقاء واختبار قوة أي علاقة ،
        ولكن في نفس الوقت سيكون عليك تقديم بعض التنازلات وذلك لإرضاء شريكك والحفاظ على علاقتكما معاً.
        قد تنجح في استيعاب الأشياء العاطفية أكثر من قبل`,
            5: `يحمل أطفال الجدي دائماً أفكاراً إبداعية بطريقة ممتازة ، لذلك عليك أن تحاول الحديث عنهم وتسليط الضوء عليهم للجميع
        سوف تجد مساعدة مفيدة والاستماع إليك ، وستكون الأشهر الأولى من عام 2020 جيدة جدًا للانفتاح والعمل والسفر
        أنت فقط لا تكون متشائما أو محبطا مهما حدث`,
            6: `زحل في الكوكب السابع الخاص بك ، والذي يتيح لك إمكانية علاقات جدية
        ويجعلك تأخذ زمام المبادرة في حب شريكك أو مع الأصدقاء واختبار قوة أي علاقة ،
        ولكن في نفس الوقت سيكون عليك تقديم بعض التنازلات وذلك لإرضاء شريكك والحفاظ على علاقتكما معاً.
        قد تنجح في استيعاب الأشياء العاطفية أكثر من قبل`,
            7: `يحمل أطفال الجدي دائماً أفكاراً إبداعية بطريقة ممتازة ، لذلك عليك أن تحاول الحديث عنهم وتسليط الضوء عليهم للجميع
        سوف تجد مساعدة مفيدة والاستماع إليك ، وستكون الأشهر الأولى من عام 2020 جيدة جدًا للانفتاح والعمل والسفر
        أنت فقط لا تكون متشائما أو محبطا مهما حدث`,
            8: `زحل في الكوكب السابع الخاص بك ، والذي يتيح لك إمكانية علاقات جدية
        ويجعلك تأخذ زمام المبادرة في حب شريكك أو مع الأصدقاء واختبار قوة أي علاقة ،
        ولكن في نفس الوقت سيكون عليك تقديم بعض التنازلات وذلك لإرضاء شريكك والحفاظ على علاقتكما معاً.
        قد تنجح في استيعاب الأشياء العاطفية أكثر من قبل`,
            9: `يحمل أطفال الجدي دائماً أفكاراً إبداعية بطريقة ممتازة ، لذلك عليك أن تحاول الحديث عنهم وتسليط الضوء عليهم للجميع
        سوف تجد مساعدة مفيدة والاستماع إليك ، وستكون الأشهر الأولى من عام 2020 جيدة جدًا للانفتاح والعمل والسفر
        أنت فقط لا تكون متشائما أو محبطا مهما حدث`,
            31: `يحمل أطفال الجدي دائماً أفكاراً إبداعية بطريقة ممتازة ، لذلك عليك أن تحاول الحديث عنهم وتسليط الضوء عليهم للجميع
        سوف تجد مساعدة مفيدة والاستماع إليك ، وستكون الأشهر الأولى من عام 2020 جيدة جدًا للانفتاح والعمل والسفر
        أنت فقط لا تكون متشائما أو محبطا مهما حدث`
        }
        
    },
    'الدلو': {
        sun_sign: {
            0: `مع بداية كانون الثاني / يناير 2020 ، مع اقتراب منتصف شهر فبراير ، سيشعر "لورانس" بصعوبة
للتعبير عن ما بداخلك قد يثير الغضب ، لكنك ستتمكن من السيطرة على هذه الأمور واحتواء الموقف و
العودة إلى علاقتك مع شريكك الهدوء والاستقرار.
تتنبأ ماجي فرح ، خبيرة البرج اللبنانية ، أنه مع ظهور Orans في منطقة العائلة ، ستواجه بعض الصدمات العائلية
أو مفاجآت وبحلول ديسمبر ستكون قريبة جدا من عائلتك`,
            1: `اختراقات المهنية.
لا تتخذ أي قرارات مالية بحلول مارس ، ولكن بحلول نهاية الربيع وبداية
الصيف ، وخاصة في مايو ، إنه وقت واعد للعمل ، ويمكنك سماع المديح والثناء على جهودك
والقدرات في العمل ، ولكن بحلول شهر يوليو ، قم بتغيير
 سوف تجني ثمار العام مع مزيد من التقدم على المستوى المهني. أنت مشغول بتغيير العالم من حولك.
فقط اتخذ بعض الخطوات وسوف تصل إلى ما تريد`,
            2: `مع بداية كانون الثاني / يناير 2020 ، مع اقتراب منتصف شهر فبراير ، سيشعر "لورانس" بصعوبة
للتعبير عن ما بداخلك قد يثير الغضب ، لكنك ستتمكن من السيطرة على هذه الأمور واحتواء الموقف و
العودة إلى علاقتك مع شريكك الهدوء والاستقرار.
تتنبأ ماجي فرح ، خبيرة البرج اللبنانية ، أنه مع ظهور Orans في منطقة العائلة ، ستواجه بعض الصدمات العائلية
أو مفاجآت وبحلول ديسمبر ستكون قريبة جدا من عائلتك`,
            3: `اختراقات المهنية.
لا تتخذ أي قرارات مالية بحلول مارس ، ولكن بحلول نهاية الربيع وبداية
الصيف ، وخاصة في مايو ، إنه وقت واعد للعمل ، ويمكنك سماع المديح والثناء على جهودك
والقدرات في العمل ، ولكن بحلول شهر يوليو ، قم بتغيير
 سوف تجني ثمار العام مع مزيد من التقدم على المستوى المهني. أنت مشغول بتغيير العالم من حولك.
فقط اتخذ بعض الخطوات وسوف تصل إلى ما تريد`,
            4: `مع بداية كانون الثاني / يناير 2020 ، مع اقتراب منتصف شهر فبراير ، سيشعر "لورانس" بصعوبة
للتعبير عن ما بداخلك قد يثير الغضب ، لكنك ستتمكن من السيطرة على هذه الأمور واحتواء الموقف و
العودة إلى علاقتك مع شريكك الهدوء والاستقرار.
تتنبأ ماجي فرح ، خبيرة البرج اللبنانية ، أنه مع ظهور Orans في منطقة العائلة ، ستواجه بعض الصدمات العائلية
أو مفاجآت وبحلول ديسمبر ستكون قريبة جدا من عائلتك`,
            5: `اختراقات المهنية.
لا تتخذ أي قرارات مالية بحلول مارس ، ولكن بحلول نهاية الربيع وبداية
الصيف ، وخاصة في مايو ، إنه وقت واعد للعمل ، ويمكنك سماع المديح والثناء على جهودك
والقدرات في العمل ، ولكن بحلول شهر يوليو ، قم بتغيير
 سوف تجني ثمار العام مع مزيد من التقدم على المستوى المهني. أنت مشغول بتغيير العالم من حولك.
فقط اتخذ بعض الخطوات وسوف تصل إلى ما تريد`,
            6: `مع بداية كانون الثاني / يناير 2020 ، مع اقتراب منتصف شهر فبراير ، سيشعر "لورانس" بصعوبة
للتعبير عن ما بداخلك قد يثير الغضب ، لكنك ستتمكن من السيطرة على هذه الأمور واحتواء الموقف و
العودة إلى علاقتك مع شريكك الهدوء والاستقرار.
تتنبأ ماجي فرح ، خبيرة البرج اللبنانية ، أنه مع ظهور Orans في منطقة العائلة ، ستواجه بعض الصدمات العائلية
أو مفاجآت وبحلول ديسمبر ستكون قريبة جدا من عائلتك`,
            7: `اختراقات المهنية.
لا تتخذ أي قرارات مالية بحلول مارس ، ولكن بحلول نهاية الربيع وبداية
الصيف ، وخاصة في مايو ، إنه وقت واعد للعمل ، ويمكنك سماع المديح والثناء على جهودك
والقدرات في العمل ، ولكن بحلول شهر يوليو ، قم بتغيير
 سوف تجني ثمار العام مع مزيد من التقدم على المستوى المهني. أنت مشغول بتغيير العالم من حولك.
فقط اتخذ بعض الخطوات وسوف تصل إلى ما تريد`,
            8: `مع بداية كانون الثاني / يناير 2020 ، مع اقتراب منتصف شهر فبراير ، سيشعر "لورانس" بصعوبة
للتعبير عن ما بداخلك قد يثير الغضب ، لكنك ستتمكن من السيطرة على هذه الأمور واحتواء الموقف و
العودة إلى علاقتك مع شريكك الهدوء والاستقرار.
تتنبأ ماجي فرح ، خبيرة البرج اللبنانية ، أنه مع ظهور Orans في منطقة العائلة ، ستواجه بعض الصدمات العائلية
أو مفاجآت وبحلول ديسمبر ستكون قريبة جدا من عائلتك`,
            9: `اختراقات المهنية.
لا تتخذ أي قرارات مالية بحلول مارس ، ولكن بحلول نهاية الربيع وبداية
الصيف ، وخاصة في مايو ، إنه وقت واعد للعمل ، ويمكنك سماع المديح والثناء على جهودك
والقدرات في العمل ، ولكن بحلول شهر يوليو ، قم بتغيير
 سوف تجني ثمار العام مع مزيد من التقدم على المستوى المهني. أنت مشغول بتغيير العالم من حولك.
فقط اتخذ بعض الخطوات وسوف تصل إلى ما تريد`,  
            31: `مع بداية كانون الثاني / يناير 2020 ، مع اقتراب منتصف شهر فبراير ، سيشعر "لورانس" بصعوبة
للتعبير عن ما بداخلك قد يثير الغضب ، لكنك ستتمكن من السيطرة على هذه الأمور واحتواء الموقف و
العودة إلى علاقتك مع شريكك الهدوء والاستقرار.
تتنبأ ماجي فرح ، خبيرة البرج اللبنانية ، أنه مع ظهور Orans في منطقة العائلة ، ستواجه بعض الصدمات العائلية
أو مفاجآت وبحلول ديسمبر ستكون قريبة جدا من عائلتك`,          

        }
    },
    'برج الحوت': {
        sun_sign: {
            0: `تخبرك ماجي فرح أن  لديها العديد من الشكوك والأسئلة حول مصيرك العاطفي مع شريكك.
ومع ذلك ، 2020 يجلب لك أشياء سعيدة شريطة أن تعرف كيف تتعامل مع شريك حياتك
خاصة بعد تجربة بعض المشاكل والمطبات في علاقتك. في النهاية ستنجح في جذب الشريك`,
            1: `تنجح في تنظيم حياتك المهنية ، يبدو أنك مستعد للتحرك في مجموعة متنوعة من الاتجاهات على المستوى المهني.
وستقوم بتنفيذ الأوراق المالية المتعلقة بالميراث أو الممتلكات.`,
            3: `تخبرك ماجي فرح أن  لديها العديد من الشكوك والأسئلة حول مصيرك العاطفي مع شريكك.
ومع ذلك ، 2020 يجلب لك أشياء سعيدة شريطة أن تعرف كيف تتعامل مع شريك حياتك
خاصة بعد تجربة بعض المشاكل والمطبات في علاقتك. في النهاية ستنجح في جذب الشريك`,
            4: `تنجح في تنظيم حياتك المهنية ، يبدو أنك مستعد للتحرك في مجموعة متنوعة من الاتجاهات على المستوى المهني.
وستقوم بتنفيذ الأوراق المالية المتعلقة بالميراث أو الممتلكات.`,
            5: `تخبرك ماجي فرح أن  لديها العديد من الشكوك والأسئلة حول مصيرك العاطفي مع شريكك.
ومع ذلك ، 2020 يجلب لك أشياء سعيدة شريطة أن تعرف كيف تتعامل مع شريك حياتك
خاصة بعد تجربة بعض المشاكل والمطبات في علاقتك. في النهاية ستنجح في جذب الشريك`,
            6: `تنجح في تنظيم حياتك المهنية ، يبدو أنك مستعد للتحرك في مجموعة متنوعة من الاتجاهات على المستوى المهني.
وستقوم بتنفيذ الأوراق المالية المتعلقة بالميراث أو الممتلكات.`,
            7: `تخبرك ماجي فرح أن  لديها العديد من الشكوك والأسئلة حول مصيرك العاطفي مع شريكك.
ومع ذلك ، 2020 يجلب لك أشياء سعيدة شريطة أن تعرف كيف تتعامل مع شريك حياتك
خاصة بعد تجربة بعض المشاكل والمطبات في علاقتك. في النهاية ستنجح في جذب الشريك`,
            8: `تنجح في تنظيم حياتك المهنية ، يبدو أنك مستعد للتحرك في مجموعة متنوعة من الاتجاهات على المستوى المهني.
وستقوم بتنفيذ الأوراق المالية المتعلقة بالميراث أو الممتلكات.`,
            9: `تخبرك ماجي فرح أن  لديها العديد من الشكوك والأسئلة حول مصيرك العاطفي مع شريكك.
ومع ذلك ، 2020 يجلب لك أشياء سعيدة شريطة أن تعرف كيف تتعامل مع شريك حياتك
خاصة بعد تجربة بعض المشاكل والمطبات في علاقتك. في النهاية ستنجح في جذب الشريك`,
            31: `تنجح في تنظيم حياتك المهنية ، يبدو أنك مستعد للتحرك في مجموعة متنوعة من الاتجاهات على المستوى المهني.
وستقوم بتنفيذ الأوراق المالية المتعلقة بالميراث أو الممتلكات.`,

            
        }
    },
}
export const tarot_ar = {
    0: `سوف تكون في عقلين اليوم. من ناحية تريد أن تكون وحيدا وان تتامل، من ناحية أخرى تريد التعبير عن حبك صراحة (كما تقترح الشمس). في الواقع ، عزيزي ، هذه المجموعة من البطاقات تخبرك بأنك ستستفيد من الخروج من عالمك الصغير والانفتاح على الآخرين. على الرغم من أنه ليس من أسلوبك أن تصدر إعلانات، فسوف تكون قادراً على تخطي صدق وعمق مشاعرك. في العمل ، يمزج الجمع بين الحكم و جو كئيب - تشعر كما لو كنت تواجه صعوبة كبيرة في تحويل طموحاتك إلى واقع. صحيح أن الأحداث التي تقع خارج نطاق سيطرتك قد تعرقل خططك أو تحد من تأثير مقترحاتك. أنت لا تملك أفكارًا قصيرة ، ولكنها لا تصل إليك كما تأمل. لا تفقد قلبك`,
    3: `سوف تكون في عقلين اليوم. من ناحية تريد أن تكون وحيدا وان تتامل، من ناحية أخرى تريد التعبير عن حبك صراحة (كما تقترح الشمس). في الواقع ، عزيزي ، هذه المجموعة من البطاقات تخبرك بأنك ستستفيد من الخروج من عالمك الصغير والانفتاح على الآخرين. على الرغم من أنه ليس من أسلوبك أن تصدر إعلانات، فسوف تكون قادراً على تخطي صدق وعمق مشاعرك. في العمل ، يمزج الجمع بين الحكم و جو كئيب - تشعر كما لو كنت تواجه صعوبة كبيرة في تحويل طموحاتك إلى واقع. صحيح أن الأحداث التي تقع خارج نطاق سيطرتك قد تعرقل خططك أو تحد من تأثير مقترحاتك. أنت لا تملك أفكارًا قصيرة ، ولكنها لا تصل إليك كما تأمل. لا تفقد قلبك`,
    6: `سوف تكون في عقلين اليوم. من ناحية تريد أن تكون وحيدا وان تتامل، من ناحية أخرى تريد التعبير عن حبك صراحة (كما تقترح الشمس). في الواقع ، عزيزي ، هذه المجموعة من البطاقات تخبرك بأنك ستستفيد من الخروج من عالمك الصغير والانفتاح على الآخرين. على الرغم من أنه ليس من أسلوبك أن تصدر إعلانات، فسوف تكون قادراً على تخطي صدق وعمق مشاعرك. في العمل ، يمزج الجمع بين الحكم و جو كئيب - تشعر كما لو كنت تواجه صعوبة كبيرة في تحويل طموحاتك إلى واقع. صحيح أن الأحداث التي تقع خارج نطاق سيطرتك قد تعرقل خططك أو تحد من تأثير مقترحاتك. أنت لا تملك أفكارًا قصيرة ، ولكنها لا تصل إليك كما تأمل. لا تفقد قلبك`,
    9: `سوف تكون في عقلين اليوم. من ناحية تريد أن تكون وحيدا وان تتامل، من ناحية أخرى تريد التعبير عن حبك صراحة (كما تقترح الشمس). في الواقع ، عزيزي ، هذه المجموعة من البطاقات تخبرك بأنك ستستفيد من الخروج من عالمك الصغير والانفتاح على الآخرين. على الرغم من أنه ليس من أسلوبك أن تصدر إعلانات، فسوف تكون قادراً على تخطي صدق وعمق مشاعرك. في العمل ، يمزج الجمع بين الحكم و جو كئيب - تشعر كما لو كنت تواجه صعوبة كبيرة في تحويل طموحاتك إلى واقع. صحيح أن الأحداث التي تقع خارج نطاق سيطرتك قد تعرقل خططك أو تحد من تأثير مقترحاتك. أنت لا تملك أفكارًا قصيرة ، ولكنها لا تصل إليك كما تأمل. لا تفقد قلبك`,
    12: `سوف تكون في عقلين اليوم. من ناحية تريد أن تكون وحيدا وان تتامل، من ناحية أخرى تريد التعبير عن حبك صراحة (كما تقترح الشمس). في الواقع ، عزيزي ، هذه المجموعة من البطاقات تخبرك بأنك ستستفيد من الخروج من عالمك الصغير والانفتاح على الآخرين. على الرغم من أنه ليس من أسلوبك أن تصدر إعلانات، فسوف تكون قادراً على تخطي صدق وعمق مشاعرك. في العمل ، يمزج الجمع بين الحكم و جو كئيب - تشعر كما لو كنت تواجه صعوبة كبيرة في تحويل طموحاتك إلى واقع. صحيح أن الأحداث التي تقع خارج نطاق سيطرتك قد تعرقل خططك أو تحد من تأثير مقترحاتك. أنت لا تملك أفكارًا قصيرة ، ولكنها لا تصل إليك كما تأمل. لا تفقد قلبك`
    
}



// WEBPACK FOOTER //
// ./src/utils/horoscope_ar.js